{
  "en": {
    "· обложка без надписей": "· cover without text",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1}: {2} does not accept {3} on photos",
    "{0}, слайд {1}": "{0}, slide {1}",
    "{0}, слайд {1} из {2}": "{0}, slide {1} of {2}",
    "18 × 16 × 8 см": "18 × 16 × 8 cm",
    "250 г": "250 g",
    "40 ч": "40 h",
    "Активное шумоподавление": "Active noise cancellation",
    "Без надписей": "Without text",
    "Беспроводные наушники": "Wireless headphones",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "The bot has already sent them to the chat, in a separate topic. The text is set by a template, without AI typos: tap it on a slide to correct it.",
    "Быстрая зарядка за 10 минут": "Fast charging in 10 minutes",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "The description has no facts about the product. Add some details.",
    "Вес": "Weight",
    "Видео товара, 5 сек": "Product video, 5 s",
    "Возьмём только факты из вашего текста": "We will take only the facts from your text",
    "Время работы": "Battery life",
    "Все оформления": "All designs",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "Paste the description from a product card or a supplier. Lines like «Weight: 250 g» become specifications",
    "Вырезаем товар": "Cutting out the product",
    "Главное фото как есть": "The main photo as it is",
    "Главное фото на обложку, остальные в слайды": "The main photo goes on the cover, the rest into the slides",
    "Главное фото пойдёт на обложку": "The main photo will go on the cover",
    "Глубина": "Depth",
    "Графит, светлый текст и золотой акцент": "Graphite, light text and a gold accent",
    "Детали": "Details",
    "Детский": "Kids",
    "Детское": "Kids",
    "Диагонали, жирный курсив и контраст": "Diagonals, bold italics and contrast",
    "До 40 часов без подзарядки": "Up to 40 hours without recharging",
    "До 5 ракурсов, главное пойдёт на обложку": "Up to 5 angles, the main one goes on the cover",
    "Добавить {0}": "Add {0}",
    "Добавить строку": "Add a row",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "Add product properties or lines like «Weight: 250 g» to the text",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "Add at least {0} benefits, each on a new line",
    "Дом": "Home",
    "доставку, возврат": "delivery and returns",
    "другое": "other things",
    "Еда": "Food",
    "ещё {0}": "{0} more",
    "Журнал": "Magazine",
    "за слайд": "per slide",
    "Загружаем фото": "Uploading photos",
    "Загрузите фото товара": "Upload a product photo",
    "Заполнить из описания": "Fill from a description",
    "Зарядка": "Charging",
    "заявления об оригинальности": "claims of originality",
    "Значение": "Value",
    "Значение {0}": "Value {0}",
    "Из фотосессии товара · главное фото на обложке": "From the product photo shoot · the main photo is on the cover",
    "Изменить текст": "Edit text",
    "Искать среди {0} оформлений": "Search among {0} designs",
    "К описанию": "Back to the description",
    "карусель": "carousel",
    "Ко всем оформлениям": "To all designs",
    "Комплектация": "Package contents",
    "Красота": "Beauty",
    "Крафт, бежевый и приглушённый зелёный": "Kraft paper, beige and muted green",
    "Круглые формы, тёплый фон и крупные значки": "Rounded shapes, a warm background and large icons",
    "Крупная антиква и свободная вёрстка": "Large serif type and an airy layout",
    "места нет": "no room",
    "Минимал": "Minimal",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "You can leave this screen: the bot will message you when the slides are ready.",
    "Мягкие амбушюры": "Soft ear cushions",
    "Мягкие амбушюры из эко-кожи": "Soft eco-leather ear cushions",
    "Мягкие градиенты и глянцевый подиум": "Soft gradients and a glossy podium",
    "на слайдах": "on the slides",
    "Набираем текст шаблоном": "Setting the text with a template",
    "Набираем шрифтом, без ошибок нейросети": "Set in a font, without AI typos",
    "Нажмите, чтобы выбрать оформление": "Tap to choose a design",
    "Название длиннее {0} знаков": "The name is longer than {0} characters",
    "Название и от {0} преимуществ": "A name and at least {0} benefits",
    "Название и преимущества": "Name and benefits",
    "Название и преимущество": "Name and a benefit",
    "Название товара": "Product name",
    "Найти преимущества": "Find benefits",
    "Напишите заголовок или текст": "Write a heading or text",
    "Напишите название товара первой строкой": "Write the product name on the first line",
    "Насыщенный фон и крупные плашки с цифрами": "A rich background and large number badges",
    "Не взяли {0}: на фото площадки так нельзя": "Skipped {0}: the platform does not allow it on photos",
    "Не получилось собрать слайды": "Could not assemble the slides",
    "Не удалось перерисовать слайд. Текст остался прежним.": "Could not redraw the slide. The text stays the same.",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "Could not read the description. Try again.",
    "Нечего добавить, вернитесь к описанию": "Nothing to add, go back to the description",
    "Нужно от {0} знаков описания": "The description needs at least {0} characters",
    "Об оформлении": "About the design",
    "обещания": "promises",
    "Обложка": "Cover",
    "Одежда": "Clothing",
    "Описание длиннее {0} знаков": "The description is longer than {0} characters",
    "Описание или характеристики": "Description or specifications",
    "Отметьте, что добавить": "Mark what to add",
    "Оформление «{0}»": "Design «{0}»",
    "Оформления": "Designs",
    "Пастель": "Pastel",
    "Перед скачиванием уберите": "Before downloading, remove",
    "Перерисовываем слайд…": "Redrawing the slide…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "We will redraw the slide with the same template, without a new generation.",
    "Подтвердите права на фото": "Confirm the rights to the photos",
    "Подтверждаю право использовать фото товара": "I confirm the right to use the product photos",
    "Подходит для": "Suits",
    "Поиск оформлений": "Search designs",
    "поместится {0}": "{0} will fit",
    "Поместится только {0}: снимите другую отметку": "Only {0} will fit: clear another mark",
    "Попробуйте другое слово или сбросьте категорию": "Try another word or reset the category",
    "Права на фото товара": "Rights to the product photos",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "The edit is not confirmed. Continue checking the same request.",
    "превосходные степени": "superlatives",
    "Предыдущий слайд": "Previous slide",
    "Преимуществ до {0}: уберите лишние строки": "Up to {0} benefits: remove the extra lines",
    "Преимуществ уже шесть: уберите лишнее в форме": "There are already six benefits: remove some in the form",
    "Преимуществ: {0} из {1}": "Benefits: {0} of {1}",
    "Преимущество {0}": "Benefit {0}",
    "Преимущество длиннее {0} знаков: сократите строку": "A benefit is longer than {0} characters: shorten the line",
    "Премиум": "Premium",
    "призывы": "calls to action",
    "Проверьте описание: сервер его не принял.": "Check the description: the server did not accept it.",
    "Проверьте текст слайда: сервер его не принял.": "Check the slide text: the server did not accept it.",
    "Проверяем фото и текст": "Checking the photos and the text",
    "Разбор описания пока недоступен. Заполните поле вручную.": "Reading the description is not available yet. Fill in the field by hand.",
    "Размер": "Size",
    "Рисуем фон без текста": "Drawing a background without text",
    "С надписями": "With text",
    "Светлое дерево и мягкие тени": "Light wood and soft shadows",
    "Светлый фон, тонкий шрифт и много воздуха": "A light background, a thin font and lots of air",
    "Свойство": "Property",
    "Свойство {0}": "Property {0}",
    "Сделайте снимок или закройте камеру": "Take a shot or close the camera",
    "Сетка, выноски и моноширинные цифры": "A grid, callouts and monospaced digits",
    "Сканди": "Scandi",
    "Скачать всё": "Download all",
    "Сколько слайдов": "How many slides",
    "слайд": "slide",
    "Слайд {0}": "Slide {0}",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "The slide has already been changed. We refreshed the result — check the text and save again.",
    "слайда": "slides",
    "слайдов": "slides",
    "слайды": "slides",
    "Слайды готовы": "The slides are ready",
    "Слайды ещё загружаются": "The slides are still loading",
    "Слайды набора": "Slides in the set",
    "слайды не созданы": "the slides were not created",
    "Слайды с преимуществами": "Benefit slides",
    "Следующий слайд": "Next slide",
    "Собираем слайды": "Assembling the slides",
    "Создать {0}": "Create {0}",
    "Создать {0} {1} · {2} C": "Create {0} {1} · {2} C",
    "Спорт": "Sport",
    "сравнения": "comparisons",
    "ссылки, контакты": "links and contacts",
    "Стекло": "Glass",
    "Страна": "Country",
    "строк": "rows",
    "строка": "row",
    "строки": "rows",
    "Текст длиннее {0} знаков": "The text is longer than {0} characters",
    "Текст на слайдах": "Text on the slides",
    "Текст набран": "The text is set",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "The text does not fit on the slide. Shorten the heading or the text.",
    "Технический": "Technical",
    "Товар в сцене": "Product in a scene",
    "Товар вырезан": "The product is cut out",
    "Тут откроется тема чата, куда бот прислал слайды": "The chat topic where the bot sent the slides will open here",
    "Уберите": "Remove",
    "Убрать строку {0}": "Remove row {0}",
    "Удерживайте, чтобы посмотреть все слайды": "Hold to see all the slides",
    "Фон готов": "The background is ready",
    "Фото и текст проверены": "Photos and text checked",
    "Фото или текст не прошли проверку": "The photos or the text did not pass the check",
    "Характеристик уже восемь": "There are already eight specifications",
    "Характеристики": "Specifications",
    "Цветная сцена и прозрачные плашки": "A colorful scene and transparent badges",
    "Цена": "Price",
    "Цены, призывы и превосходные степени не возьмём": "We will not take prices, calls to action or superlatives",
    "цены, скидки": "prices and discounts",
    "Что нашли": "What we found",
    "шаблон": "template",
    "шаблона": "templates",
    "шаблонов": "templates",
    "Эко": "Eco",
    "Электроника": "Electronics",
    "Этот вариант пока недоступен": "This option is not available yet",
    "Этот слайд больше нельзя изменить.": "This slide can no longer be edited.",
    "Этот слайд нельзя изменить": "This slide cannot be edited",
    "Я.Маркет": "Y.Market",
    "Яркий": "Bright",
    "C за слайд": "C per slide",
    "Ozon Fresh принимает обложку только без текста": "Ozon Fresh accepts only a cover without text"
  },
  "hy": {
    "· обложка без надписей": "· շապիկ առանց գրությունների",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1}. {2}-ն լուսանկարներում չի ընդունում {3}",
    "{0}, слайд {1}": "{0}, սլայդ {1}",
    "{0}, слайд {1} из {2}": "{0}, սլայդ {1}՝ {2}-ից",
    "18 × 16 × 8 см": "18 × 16 × 8 սմ",
    "250 г": "250 գ",
    "40 ч": "40 ժ",
    "Активное шумоподавление": "Աղմուկի ակտիվ ճնշում",
    "Без надписей": "Առանց գրությունների",
    "Беспроводные наушники": "Անլար ականջակալներ",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "Բոտն արդեն ուղարկել է դրանք չատ՝ առանձին թեմայով։ Տեքստը շարված է ձևանմուշով, առանց նեյրոցանցի սխալների․ սեղմեք սլայդի տեքստին՝ ուղղելու համար։",
    "Быстрая зарядка за 10 минут": "Արագ լիցքավորում 10 րոպեում",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "Նկարագրության մեջ ապրանքի մասին փաստեր չգտնվեցին։ Ավելացրեք մանրամասներ։",
    "Вес": "Քաշ",
    "Видео товара, 5 сек": "Ապրանքի տեսանյութ, 5 վ",
    "Возьмём только факты из вашего текста": "Կվերցնենք միայն ձեր տեքստի փաստերը",
    "Время работы": "Աշխատանքի տևողություն",
    "Все оформления": "Բոլոր ձևավորումները",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "Տեղադրեք նկարագրությունը քարտից կամ մատակարարից։ «Քաշ՝ 250 գ» տիպի տողերը կդառնան բնութագրեր",
    "Вырезаем товар": "Կտրում ենք ապրանքը",
    "Главное фото как есть": "Գլխավոր լուսանկարն ինչպես կա",
    "Главное фото на обложку, остальные в слайды": "Գլխավոր լուսանկարը՝ շապիկին, մյուսները՝ սլայդներում",
    "Главное фото пойдёт на обложку": "Գլխավոր լուսանկարը կլինի շապիկին",
    "Глубина": "Խորություն",
    "Графит, светлый текст и золотой акцент": "Գրաֆիտ, բաց տեքստ և ոսկե շեշտ",
    "Детали": "Մանրամասներ",
    "Детский": "Մանկական",
    "Детское": "Մանկական",
    "Диагонали, жирный курсив и контраст": "Անկյունագծեր, թավ շեղատառ և կոնտրաստ",
    "До 40 часов без подзарядки": "Մինչև 40 ժամ առանց լիցքավորման",
    "До 5 ракурсов, главное пойдёт на обложку": "Մինչև 5 տեսանկյուն, գլխավորը կլինի շապիկին",
    "Добавить {0}": "Ավելացնել {0}",
    "Добавить строку": "Ավելացնել տող",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "Ավելացրեք տեքստում ապրանքի հատկություններ կամ «Քաշ՝ 250 գ» տիպի տողեր",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "Ավելացրեք առնվազն {0} առավելություն՝ յուրաքանչյուրը նոր տողից",
    "Дом": "Տուն",
    "доставку, возврат": "առաքում և վերադարձ",
    "другое": "այլ բաներ",
    "Еда": "Սնունդ",
    "ещё {0}": "ևս {0}",
    "Журнал": "Ամսագիր",
    "за слайд": "մեկ սլայդի համար",
    "Загружаем фото": "Վերբեռնում ենք լուսանկարները",
    "Загрузите фото товара": "Վերբեռնեք ապրանքի լուսանկարը",
    "Заполнить из описания": "Լրացնել նկարագրությունից",
    "Зарядка": "Լիցքավորում",
    "заявления об оригинальности": "բնօրինակության մասին հայտարարություններ",
    "Значение": "Արժեք",
    "Значение {0}": "Արժեք {0}",
    "Из фотосессии товара · главное фото на обложке": "Ապրանքի ֆոտոշարքից · գլխավոր լուսանկարը շապիկին",
    "Изменить текст": "Փոխել տեքստը",
    "Искать среди {0} оформлений": "Որոնել {0} ձևավորումների մեջ",
    "К описанию": "Դեպի նկարագրություն",
    "карусель": "կարուսել",
    "Ко всем оформлениям": "Դեպի բոլոր ձևավորումները",
    "Комплектация": "Կոմպլեկտացիա",
    "Красота": "Գեղեցկություն",
    "Крафт, бежевый и приглушённый зелёный": "Կրաֆտ, բեժ և մեղմ կանաչ",
    "Круглые формы, тёплый фон и крупные значки": "Կլոր ձևեր, տաք ֆոն և խոշոր պատկերակներ",
    "Крупная антиква и свободная вёрстка": "Խոշոր անտիկվա և ազատ դասավորություն",
    "места нет": "տեղ չկա",
    "Минимал": "Մինիմալ",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "Կարող եք լքել էկրանը․ բոտը կգրի, երբ սլայդները պատրաստ լինեն։",
    "Мягкие амбушюры": "Փափուկ բարձիկներ",
    "Мягкие амбушюры из эко-кожи": "Էկո-կաշվե փափուկ բարձիկներ",
    "Мягкие градиенты и глянцевый подиум": "Մեղմ գրադիենտներ և փայլուն պոդիում",
    "на слайдах": "սլայդներում",
    "Набираем текст шаблоном": "Տեքստը շարում ենք ձևանմուշով",
    "Набираем шрифтом, без ошибок нейросети": "Շարում ենք տառատեսակով, առանց նեյրոցանցի սխալների",
    "Нажмите, чтобы выбрать оформление": "Սեղմեք՝ ձևավորում ընտրելու համար",
    "Название длиннее {0} знаков": "Անվանումը {0} նիշից երկար է",
    "Название и от {0} преимуществ": "Անվանում և առնվազն {0} առավելություն",
    "Название и преимущества": "Անվանում և առավելություններ",
    "Название и преимущество": "Անվանում և առավելություն",
    "Название товара": "Ապրանքի անվանում",
    "Найти преимущества": "Գտնել առավելությունները",
    "Напишите заголовок или текст": "Գրեք վերնագիր կամ տեքստ",
    "Напишите название товара первой строкой": "Գրեք ապրանքի անվանումն առաջին տողում",
    "Насыщенный фон и крупные плашки с цифрами": "Հագեցած ֆոն և թվերով խոշոր պիտակներ",
    "Не взяли {0}: на фото площадки так нельзя": "{0}-ը չվերցրինք․ հարթակը լուսանկարներում դա չի թույլատրում",
    "Не получилось собрать слайды": "Չհաջողվեց հավաքել սլայդները",
    "Не удалось перерисовать слайд. Текст остался прежним.": "Չհաջողվեց վերագծել սլայդը։ Տեքստը մնաց նույնը։",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "Չհաջողվեց վերլուծել նկարագրությունը։ Փորձեք կրկին։",
    "Нечего добавить, вернитесь к описанию": "Ավելացնելու բան չկա, վերադարձեք նկարագրությանը",
    "Нужно от {0} знаков описания": "Նկարագրությունը պետք է լինի առնվազն {0} նիշ",
    "Об оформлении": "Ձևավորման մասին",
    "обещания": "խոստումներ",
    "Обложка": "Շապիկ",
    "Одежда": "Հագուստ",
    "Описание длиннее {0} знаков": "Նկարագրությունը {0} նիշից երկար է",
    "Описание или характеристики": "Նկարագրություն կամ բնութագրեր",
    "Отметьте, что добавить": "Նշեք, թե ինչ ավելացնել",
    "Оформление «{0}»": "«{0}» ձևավորում",
    "Оформления": "Ձևավորումներ",
    "Пастель": "Պաստել",
    "Перед скачиванием уберите": "Ներբեռնելուց առաջ հեռացրեք",
    "Перерисовываем слайд…": "Վերագծում ենք սլայդը…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "Կվերագծենք սլայդը նույն ձևանմուշով, առանց նոր գեներացիայի։",
    "Подтвердите права на фото": "Հաստատեք լուսանկարների իրավունքը",
    "Подтверждаю право использовать фото товара": "Հաստատում եմ ապրանքի լուսանկարներն օգտագործելու իրավունքը",
    "Подходит для": "Հարմար է",
    "Поиск оформлений": "Ձևավորումների որոնում",
    "поместится {0}": "կտեղավորվի {0}",
    "Поместится только {0}: снимите другую отметку": "Կտեղավորվի միայն {0}․ հանեք մեկ այլ նշում",
    "Попробуйте другое слово или сбросьте категорию": "Փորձեք այլ բառ կամ չեղարկեք կատեգորիան",
    "Права на фото товара": "Ապրանքի լուսանկարների իրավունքը",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Խմբագրումը չի հաստատվել։ Շարունակեք ստուգել նույն հարցումը։",
    "превосходные степени": "գերադրական աստիճաններ",
    "Предыдущий слайд": "Նախորդ սլայդ",
    "Преимуществ до {0}: уберите лишние строки": "Առավելությունները՝ մինչև {0}․ հեռացրեք ավելորդ տողերը",
    "Преимуществ уже шесть: уберите лишнее в форме": "Արդեն վեց առավելություն կա․ ավելորդը հեռացրեք ձևից",
    "Преимуществ: {0} из {1}": "Առավելություններ՝ {0}՝ {1}-ից",
    "Преимущество {0}": "Առավելություն {0}",
    "Преимущество длиннее {0} знаков: сократите строку": "Առավելությունը {0} նիշից երկար է․ կրճատեք տողը",
    "Премиум": "Պրեմիում",
    "призывы": "կոչեր",
    "Проверьте описание: сервер его не принял.": "Ստուգեք նկարագրությունը․ սերվերը այն չընդունեց։",
    "Проверьте текст слайда: сервер его не принял.": "Ստուգեք սլայդի տեքստը․ սերվերը այն չընդունեց։",
    "Проверяем фото и текст": "Ստուգում ենք լուսանկարներն ու տեքստը",
    "Разбор описания пока недоступен. Заполните поле вручную.": "Նկարագրության վերլուծությունը դեռ հասանելի չէ։ Լրացրեք դաշտը ձեռքով։",
    "Размер": "Չափս",
    "Рисуем фон без текста": "Գծում ենք առանց տեքստի ֆոն",
    "С надписями": "Գրություններով",
    "Светлое дерево и мягкие тени": "Բաց փայտ և մեղմ ստվերներ",
    "Светлый фон, тонкий шрифт и много воздуха": "Բաց ֆոն, բարակ տառատեսակ և շատ օդ",
    "Свойство": "Հատկություն",
    "Свойство {0}": "Հատկություն {0}",
    "Сделайте снимок или закройте камеру": "Լուսանկարեք կամ փակեք տեսախցիկը",
    "Сетка, выноски и моноширинные цифры": "Ցանց, ծանոթագրություններ և միալայն թվեր",
    "Сканди": "Սկանդի",
    "Скачать всё": "Ներբեռնել ամբողջը",
    "Сколько слайдов": "Քանի սլայդ",
    "слайд": "սլայդ",
    "Слайд {0}": "Սլայդ {0}",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Սլայդն արդեն փոխվել է։ Թարմացրինք արդյունքը․ ստուգեք տեքստը և նորից պահպանեք։",
    "слайда": "սլայդ",
    "слайдов": "սլայդ",
    "слайды": "սլայդները",
    "Слайды готовы": "Սլայդները պատրաստ են",
    "Слайды ещё загружаются": "Սլայդները դեռ բեռնվում են",
    "Слайды набора": "Հավաքածուի սլայդները",
    "слайды не созданы": "սլայդները չեն ստեղծվել",
    "Слайды с преимуществами": "Առավելությունների սլայդներ",
    "Следующий слайд": "Հաջորդ սլայդ",
    "Собираем слайды": "Հավաքում ենք սլայդները",
    "Создать {0}": "Ստեղծել {0}",
    "Создать {0} {1} · {2} C": "Ստեղծել {0} {1} · {2} C",
    "Спорт": "Սպորտ",
    "сравнения": "համեմատություններ",
    "ссылки, контакты": "հղումներ և կոնտակտներ",
    "Стекло": "Ապակի",
    "Страна": "Երկիր",
    "строк": "տող",
    "строка": "տող",
    "строки": "տող",
    "Текст длиннее {0} знаков": "Տեքստը {0} նիշից երկար է",
    "Текст на слайдах": "Տեքստը սլայդներում",
    "Текст набран": "Տեքստը շարված է",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Տեքստը չի տեղավորվում սլայդում։ Կրճատեք վերնագիրը կամ տեքստը։",
    "Технический": "Տեխնիկական",
    "Товар в сцене": "Ապրանքը տեսարանում",
    "Товар вырезан": "Ապրանքը կտրված է",
    "Тут откроется тема чата, куда бот прислал слайды": "Այստեղ կբացվի չատի թեման, ուր բոտն ուղարկել է սլայդները",
    "Уберите": "Հեռացրեք",
    "Убрать строку {0}": "Հեռացնել {0} տողը",
    "Удерживайте, чтобы посмотреть все слайды": "Սեղմած պահեք՝ բոլոր սլայդները տեսնելու համար",
    "Фон готов": "Ֆոնը պատրաստ է",
    "Фото и текст проверены": "Լուսանկարներն ու տեքստը ստուգված են",
    "Фото или текст не прошли проверку": "Լուսանկարները կամ տեքստը ստուգումը չանցան",
    "Характеристик уже восемь": "Արդեն ութ բնութագիր կա",
    "Характеристики": "Բնութագրեր",
    "Цветная сцена и прозрачные плашки": "Գունավոր տեսարան և թափանցիկ պիտակներ",
    "Цена": "Գին",
    "Цены, призывы и превосходные степени не возьмём": "Գներ, կոչեր և գերադրական աստիճաններ չենք վերցնի",
    "цены, скидки": "գներ և զեղչեր",
    "Что нашли": "Ինչ գտանք",
    "шаблон": "ձևանմուշ",
    "шаблона": "ձևանմուշ",
    "шаблонов": "ձևանմուշ",
    "Эко": "Էկո",
    "Электроника": "Էլեկտրոնիկա",
    "Этот вариант пока недоступен": "Այս տարբերակը դեռ հասանելի չէ",
    "Этот слайд больше нельзя изменить.": "Այս սլայդն այլևս հնարավոր չէ փոխել։",
    "Этот слайд нельзя изменить": "Այս սլայդը հնարավոր չէ փոխել",
    "Я.Маркет": "Y.Market",
    "Яркий": "Վառ",
    "C за слайд": "C մեկ սլայդի համար",
    "Ozon Fresh принимает обложку только без текста": "Ozon Fresh-ն ընդունում է միայն առանց տեքստի շապիկ"
  },
  "es": {
    "· обложка без надписей": "· portada sin texto",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1}: {2} no acepta {3} en las fotos",
    "{0}, слайд {1}": "{0}, diapositiva {1}",
    "{0}, слайд {1} из {2}": "{0}, diapositiva {1} de {2}",
    "18 × 16 × 8 см": "18 × 16 × 8 cm",
    "250 г": "250 g",
    "40 ч": "40 h",
    "Активное шумоподавление": "Cancelación activa de ruido",
    "Без надписей": "Sin texto",
    "Беспроводные наушники": "Auriculares inalámbricos",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "El bot ya los envió al chat, en un tema aparte. El texto está compuesto con una plantilla, sin errores de la IA: tócalo en una diapositiva para corregirlo.",
    "Быстрая зарядка за 10 минут": "Carga rápida en 10 minutos",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "La descripción no tiene datos del producto. Añade detalles.",
    "Вес": "Peso",
    "Видео товара, 5 сек": "Vídeo del producto, 5 s",
    "Возьмём только факты из вашего текста": "Tomaremos solo los datos de tu texto",
    "Время работы": "Autonomía",
    "Все оформления": "Todos los diseños",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "Pega la descripción de la ficha o del proveedor. Las líneas del tipo «Peso: 250 g» se convertirán en características",
    "Вырезаем товар": "Recortando el producto",
    "Главное фото как есть": "La foto principal tal cual",
    "Главное фото на обложку, остальные в слайды": "La foto principal va a la portada, las demás a las diapositivas",
    "Главное фото пойдёт на обложку": "La foto principal irá en la portada",
    "Глубина": "Profundidad",
    "Графит, светлый текст и золотой акцент": "Grafito, texto claro y acento dorado",
    "Детали": "Detalles",
    "Детский": "Infantil",
    "Детское": "Niños",
    "Диагонали, жирный курсив и контраст": "Diagonales, cursiva negrita y contraste",
    "До 40 часов без подзарядки": "Hasta 40 horas sin recargar",
    "До 5 ракурсов, главное пойдёт на обложку": "Hasta 5 ángulos, el principal irá en la portada",
    "Добавить {0}": "Añadir {0}",
    "Добавить строку": "Añadir fila",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "Añade al texto propiedades del producto o líneas del tipo «Peso: 250 g»",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "Añade al menos {0} beneficios, cada uno en una línea",
    "Дом": "Hogar",
    "доставку, возврат": "envíos y devoluciones",
    "другое": "otras cosas",
    "Еда": "Comida",
    "ещё {0}": "{0} más",
    "Журнал": "Revista",
    "за слайд": "por diapositiva",
    "Загружаем фото": "Subiendo fotos",
    "Загрузите фото товара": "Sube una foto del producto",
    "Заполнить из описания": "Rellenar desde una descripción",
    "Зарядка": "Carga",
    "заявления об оригинальности": "declaraciones de originalidad",
    "Значение": "Valor",
    "Значение {0}": "Valor {0}",
    "Из фотосессии товара · главное фото на обложке": "De la sesión de fotos del producto · la foto principal en la portada",
    "Изменить текст": "Editar texto",
    "Искать среди {0} оформлений": "Buscar entre {0} diseños",
    "К описанию": "A la descripción",
    "карусель": "carrusel",
    "Ко всем оформлениям": "A todos los diseños",
    "Комплектация": "Contenido",
    "Красота": "Belleza",
    "Крафт, бежевый и приглушённый зелёный": "Kraft, beige y verde apagado",
    "Круглые формы, тёплый фон и крупные значки": "Formas redondas, fondo cálido e iconos grandes",
    "Крупная антиква и свободная вёрстка": "Serifa grande y maquetación libre",
    "места нет": "no hay espacio",
    "Минимал": "Minimal",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "Puedes salir de la pantalla: el bot te escribirá cuando las diapositivas estén listas.",
    "Мягкие амбушюры": "Almohadillas suaves",
    "Мягкие амбушюры из эко-кожи": "Almohadillas suaves de piel ecológica",
    "Мягкие градиенты и глянцевый подиум": "Degradados suaves y podio brillante",
    "на слайдах": "en las diapositivas",
    "Набираем текст шаблоном": "Componiendo el texto con plantilla",
    "Набираем шрифтом, без ошибок нейросети": "Compuesto con fuente, sin errores de IA",
    "Нажмите, чтобы выбрать оформление": "Toca para elegir un diseño",
    "Название длиннее {0} знаков": "El nombre tiene más de {0} caracteres",
    "Название и от {0} преимуществ": "Nombre y al menos {0} beneficios",
    "Название и преимущества": "Nombre y beneficios",
    "Название и преимущество": "Nombre y un beneficio",
    "Название товара": "Nombre del producto",
    "Найти преимущества": "Buscar beneficios",
    "Напишите заголовок или текст": "Escribe un título o un texto",
    "Напишите название товара первой строкой": "Escribe el nombre del producto en la primera línea",
    "Насыщенный фон и крупные плашки с цифрами": "Fondo intenso y grandes placas con números",
    "Не взяли {0}: на фото площадки так нельзя": "No se tomó {0}: la plataforma no lo permite en las fotos",
    "Не получилось собрать слайды": "No se pudieron montar las diapositivas",
    "Не удалось перерисовать слайд. Текст остался прежним.": "No se pudo redibujar la diapositiva. El texto sigue igual.",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "No se pudo analizar la descripción. Inténtalo de nuevo.",
    "Нечего добавить, вернитесь к описанию": "No hay nada que añadir, vuelve a la descripción",
    "Нужно от {0} знаков описания": "La descripción necesita al menos {0} caracteres",
    "Об оформлении": "Sobre el diseño",
    "обещания": "promesas",
    "Обложка": "Portada",
    "Одежда": "Ropa",
    "Описание длиннее {0} знаков": "La descripción supera los {0} caracteres",
    "Описание или характеристики": "Descripción o características",
    "Отметьте, что добавить": "Marca lo que quieres añadir",
    "Оформление «{0}»": "Diseño «{0}»",
    "Оформления": "Diseños",
    "Пастель": "Pastel",
    "Перед скачиванием уберите": "Antes de descargar, quita",
    "Перерисовываем слайд…": "Redibujando la diapositiva…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "Redibujaremos la diapositiva con la misma plantilla, sin una nueva generación.",
    "Подтвердите права на фото": "Confirma los derechos sobre las fotos",
    "Подтверждаю право использовать фото товара": "Confirmo el derecho a usar las fotos del producto",
    "Подходит для": "Ideal para",
    "Поиск оформлений": "Buscar diseños",
    "поместится {0}": "caben {0}",
    "Поместится только {0}: снимите другую отметку": "Solo caben {0}: quita otra marca",
    "Попробуйте другое слово или сбросьте категорию": "Prueba otra palabra o quita la categoría",
    "Права на фото товара": "Derechos sobre las fotos del producto",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "La edición no está confirmada. Sigue comprobando la misma solicitud.",
    "превосходные степени": "superlativos",
    "Предыдущий слайд": "Diapositiva anterior",
    "Преимуществ до {0}: уберите лишние строки": "Hasta {0} beneficios: quita las líneas sobrantes",
    "Преимуществ уже шесть: уберите лишнее в форме": "Ya hay seis beneficios: quita alguno en el formulario",
    "Преимуществ: {0} из {1}": "Beneficios: {0} de {1}",
    "Преимущество {0}": "Beneficio {0}",
    "Преимущество длиннее {0} знаков: сократите строку": "Un beneficio tiene más de {0} caracteres: acorta la línea",
    "Премиум": "Premium",
    "призывы": "llamadas a la acción",
    "Проверьте описание: сервер его не принял.": "Revisa la descripción: el servidor no la aceptó.",
    "Проверьте текст слайда: сервер его не принял.": "Revisa el texto de la diapositiva: el servidor no lo aceptó.",
    "Проверяем фото и текст": "Comprobando las fotos y el texto",
    "Разбор описания пока недоступен. Заполните поле вручную.": "El análisis de la descripción aún no está disponible. Rellena el campo a mano.",
    "Размер": "Tamaño",
    "Рисуем фон без текста": "Dibujando un fondo sin texto",
    "С надписями": "Con texto",
    "Светлое дерево и мягкие тени": "Madera clara y sombras suaves",
    "Светлый фон, тонкий шрифт и много воздуха": "Fondo claro, fuente fina y mucho aire",
    "Свойство": "Propiedad",
    "Свойство {0}": "Propiedad {0}",
    "Сделайте снимок или закройте камеру": "Haz una foto o cierra la cámara",
    "Сетка, выноски и моноширинные цифры": "Cuadrícula, llamadas y cifras monoespaciadas",
    "Сканди": "Escandi",
    "Скачать всё": "Descargar todo",
    "Сколько слайдов": "Cuántas diapositivas",
    "слайд": "diapositiva",
    "Слайд {0}": "Diapositiva {0}",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "La diapositiva ya cambió. Actualizamos el resultado: revisa el texto y guarda de nuevo.",
    "слайда": "diapositivas",
    "слайдов": "diapositivas",
    "слайды": "diapositivas",
    "Слайды готовы": "Las diapositivas están listas",
    "Слайды ещё загружаются": "Las diapositivas aún se están cargando",
    "Слайды набора": "Diapositivas del conjunto",
    "слайды не созданы": "las diapositivas no se crearon",
    "Слайды с преимуществами": "Diapositivas de beneficios",
    "Следующий слайд": "Diapositiva siguiente",
    "Собираем слайды": "Montando las diapositivas",
    "Создать {0}": "Crear {0}",
    "Создать {0} {1} · {2} C": "Crear {0} {1} · {2} C",
    "Спорт": "Deporte",
    "сравнения": "comparaciones",
    "ссылки, контакты": "enlaces y contactos",
    "Стекло": "Cristal",
    "Страна": "País",
    "строк": "filas",
    "строка": "fila",
    "строки": "filas",
    "Текст длиннее {0} знаков": "El texto tiene más de {0} caracteres",
    "Текст на слайдах": "Texto en las diapositivas",
    "Текст набран": "Texto compuesto",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "El texto no cabe en la diapositiva. Acorta el título o el texto.",
    "Технический": "Técnico",
    "Товар в сцене": "Producto en escena",
    "Товар вырезан": "Producto recortado",
    "Тут откроется тема чата, куда бот прислал слайды": "Aquí se abrirá el tema del chat donde el bot envió las diapositivas",
    "Уберите": "Quita",
    "Убрать строку {0}": "Quitar fila {0}",
    "Удерживайте, чтобы посмотреть все слайды": "Mantén pulsado para ver todas las diapositivas",
    "Фон готов": "Fondo listo",
    "Фото и текст проверены": "Fotos y texto comprobados",
    "Фото или текст не прошли проверку": "Las fotos o el texto no superaron la revisión",
    "Характеристик уже восемь": "Ya hay ocho características",
    "Характеристики": "Características",
    "Цветная сцена и прозрачные плашки": "Escena de color y placas transparentes",
    "Цена": "Precio",
    "Цены, призывы и превосходные степени не возьмём": "No tomaremos precios, llamadas a la acción ni superlativos",
    "цены, скидки": "precios y descuentos",
    "Что нашли": "Lo que encontramos",
    "шаблон": "plantilla",
    "шаблона": "plantillas",
    "шаблонов": "plantillas",
    "Эко": "Eco",
    "Электроника": "Electrónica",
    "Этот вариант пока недоступен": "Esta opción aún no está disponible",
    "Этот слайд больше нельзя изменить.": "Esta diapositiva ya no se puede editar.",
    "Этот слайд нельзя изменить": "Esta diapositiva no se puede editar",
    "Я.Маркет": "Y.Market",
    "Яркий": "Vivo",
    "C за слайд": "C por diapositiva",
    "Ozon Fresh принимает обложку только без текста": "Ozon Fresh solo acepta una portada sin texto"
  },
  "de": {
    "· обложка без надписей": "· Cover ohne Text",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1}: {2} akzeptiert auf Fotos keine {3}",
    "{0}, слайд {1}": "{0}, Folie {1}",
    "{0}, слайд {1} из {2}": "{0}, Folie {1} von {2}",
    "18 × 16 × 8 см": "18 × 16 × 8 cm",
    "250 г": "250 g",
    "40 ч": "40 Std.",
    "Активное шумоподавление": "Aktive Geräuschunterdrückung",
    "Без надписей": "Ohne Text",
    "Беспроводные наушники": "Kabellose Kopfhörer",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "Der Bot hat sie bereits in einem eigenen Thema in den Chat geschickt. Der Text ist per Vorlage gesetzt, ohne KI-Fehler: Tippen Sie auf einer Folie darauf, um ihn zu korrigieren.",
    "Быстрая зарядка за 10 минут": "Schnellladen in 10 Minuten",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "In der Beschreibung stehen keine Fakten zum Produkt. Fügen Sie Details hinzu.",
    "Вес": "Gewicht",
    "Видео товара, 5 сек": "Produktvideo, 5 s",
    "Возьмём только факты из вашего текста": "Wir übernehmen nur Fakten aus Ihrem Text",
    "Время работы": "Laufzeit",
    "Все оформления": "Alle Designs",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "Fügen Sie die Beschreibung aus der Produktkarte oder vom Lieferanten ein. Zeilen wie «Gewicht: 250 g» werden zu Eigenschaften",
    "Вырезаем товар": "Produkt wird freigestellt",
    "Главное фото как есть": "Das Hauptfoto unverändert",
    "Главное фото на обложку, остальные в слайды": "Hauptfoto aufs Cover, die übrigen in die Folien",
    "Главное фото пойдёт на обложку": "Das Hauptfoto kommt aufs Cover",
    "Глубина": "Tiefe",
    "Графит, светлый текст и золотой акцент": "Graphit, heller Text und goldener Akzent",
    "Детали": "Details",
    "Детский": "Kinder",
    "Детское": "Kinder",
    "Диагонали, жирный курсив и контраст": "Diagonalen, fette Kursivschrift und Kontrast",
    "До 40 часов без подзарядки": "Bis zu 40 Stunden ohne Aufladen",
    "До 5 ракурсов, главное пойдёт на обложку": "Bis zu 5 Ansichten, die wichtigste kommt aufs Cover",
    "Добавить {0}": "{0} hinzufügen",
    "Добавить строку": "Zeile hinzufügen",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "Fügen Sie Produkteigenschaften oder Zeilen wie «Gewicht: 250 g» in den Text ein",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "Fügen Sie mindestens {0} Vorteile hinzu, jeden in einer neuen Zeile",
    "Дом": "Zuhause",
    "доставку, возврат": "Lieferung und Rückgabe",
    "другое": "Weiteres",
    "Еда": "Essen",
    "ещё {0}": "{0} weitere",
    "Журнал": "Magazin",
    "за слайд": "pro Folie",
    "Загружаем фото": "Fotos werden hochgeladen",
    "Загрузите фото товара": "Laden Sie ein Produktfoto hoch",
    "Заполнить из описания": "Aus Beschreibung ausfüllen",
    "Зарядка": "Laden",
    "заявления об оригинальности": "Originalitätsversprechen",
    "Значение": "Wert",
    "Значение {0}": "Wert {0}",
    "Из фотосессии товара · главное фото на обложке": "Aus dem Produkt-Fotoshooting · Hauptfoto auf dem Cover",
    "Изменить текст": "Text bearbeiten",
    "Искать среди {0} оформлений": "Unter {0} Designs suchen",
    "К описанию": "Zur Beschreibung",
    "карусель": "Karussell",
    "Ко всем оформлениям": "Zu allen Designs",
    "Комплектация": "Lieferumfang",
    "Красота": "Beauty",
    "Крафт, бежевый и приглушённый зелёный": "Kraftpapier, Beige und gedecktes Grün",
    "Круглые формы, тёплый фон и крупные значки": "Runde Formen, warmer Hintergrund und große Symbole",
    "Крупная антиква и свободная вёрстка": "Große Serifenschrift und lockeres Layout",
    "места нет": "kein Platz",
    "Минимал": "Minimal",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "Sie können den Bildschirm verlassen: Der Bot meldet sich, wenn die Folien fertig sind.",
    "Мягкие амбушюры": "Weiche Ohrpolster",
    "Мягкие амбушюры из эко-кожи": "Weiche Ohrpolster aus Kunstleder",
    "Мягкие градиенты и глянцевый подиум": "Sanfte Verläufe und glänzendes Podest",
    "на слайдах": "auf den Folien",
    "Набираем текст шаблоном": "Text wird per Vorlage gesetzt",
    "Набираем шрифтом, без ошибок нейросети": "Mit Schrift gesetzt, ohne KI-Fehler",
    "Нажмите, чтобы выбрать оформление": "Tippen, um ein Design zu wählen",
    "Название длиннее {0} знаков": "Der Name ist länger als {0} Zeichen",
    "Название и от {0} преимуществ": "Name und mindestens {0} Vorteile",
    "Название и преимущества": "Name und Vorteile",
    "Название и преимущество": "Name und ein Vorteil",
    "Название товара": "Produktname",
    "Найти преимущества": "Vorteile finden",
    "Напишите заголовок или текст": "Schreiben Sie eine Überschrift oder einen Text",
    "Напишите название товара первой строкой": "Schreiben Sie den Produktnamen in die erste Zeile",
    "Насыщенный фон и крупные плашки с цифрами": "Kräftiger Hintergrund und große Zahlenfelder",
    "Не взяли {0}: на фото площадки так нельзя": "{0} nicht übernommen: Auf den Fotos der Plattform ist das nicht erlaubt",
    "Не получилось собрать слайды": "Die Folien konnten nicht erstellt werden",
    "Не удалось перерисовать слайд. Текст остался прежним.": "Die Folie konnte nicht neu gezeichnet werden. Der Text bleibt unverändert.",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "Die Beschreibung konnte nicht ausgewertet werden. Versuchen Sie es erneut.",
    "Нечего добавить, вернитесь к описанию": "Nichts hinzuzufügen, gehen Sie zurück zur Beschreibung",
    "Нужно от {0} знаков описания": "Die Beschreibung braucht mindestens {0} Zeichen",
    "Об оформлении": "Über das Design",
    "обещания": "Versprechen",
    "Обложка": "Cover",
    "Одежда": "Kleidung",
    "Описание длиннее {0} знаков": "Die Beschreibung ist länger als {0} Zeichen",
    "Описание или характеристики": "Beschreibung oder Eigenschaften",
    "Отметьте, что добавить": "Markieren Sie, was hinzugefügt werden soll",
    "Оформление «{0}»": "Design «{0}»",
    "Оформления": "Designs",
    "Пастель": "Pastell",
    "Перед скачиванием уберите": "Entfernen Sie vor dem Herunterladen",
    "Перерисовываем слайд…": "Folie wird neu gezeichnet…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "Wir zeichnen die Folie mit derselben Vorlage neu, ohne neue Generierung.",
    "Подтвердите права на фото": "Bestätigen Sie die Rechte an den Fotos",
    "Подтверждаю право использовать фото товара": "Ich bestätige das Recht, die Produktfotos zu verwenden",
    "Подходит для": "Passt zu",
    "Поиск оформлений": "Designs suchen",
    "поместится {0}": "{0} passen",
    "Поместится только {0}: снимите другую отметку": "Nur {0} passen hinein: Entfernen Sie eine andere Markierung",
    "Попробуйте другое слово или сбросьте категорию": "Versuchen Sie ein anderes Wort oder setzen Sie die Kategorie zurück",
    "Права на фото товара": "Rechte an den Produktfotos",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Die Änderung ist nicht bestätigt. Prüfen Sie dieselbe Anfrage weiter.",
    "превосходные степени": "Superlative",
    "Предыдущий слайд": "Vorherige Folie",
    "Преимуществ до {0}: уберите лишние строки": "Höchstens {0} Vorteile: Entfernen Sie überzählige Zeilen",
    "Преимуществ уже шесть: уберите лишнее в форме": "Es gibt schon sechs Vorteile: Entfernen Sie im Formular welche",
    "Преимуществ: {0} из {1}": "Vorteile: {0} von {1}",
    "Преимущество {0}": "Vorteil {0}",
    "Преимущество длиннее {0} знаков: сократите строку": "Ein Vorteil ist länger als {0} Zeichen: Kürzen Sie die Zeile",
    "Премиум": "Premium",
    "призывы": "Handlungsaufrufe",
    "Проверьте описание: сервер его не принял.": "Prüfen Sie die Beschreibung: Der Server hat sie nicht angenommen.",
    "Проверьте текст слайда: сервер его не принял.": "Prüfen Sie den Folientext: Der Server hat ihn nicht angenommen.",
    "Проверяем фото и текст": "Fotos und Text werden geprüft",
    "Разбор описания пока недоступен. Заполните поле вручную.": "Das Auswerten der Beschreibung ist noch nicht verfügbar. Füllen Sie das Feld manuell aus.",
    "Размер": "Größe",
    "Рисуем фон без текста": "Hintergrund ohne Text wird gezeichnet",
    "С надписями": "Mit Text",
    "Светлое дерево и мягкие тени": "Helles Holz und weiche Schatten",
    "Светлый фон, тонкий шрифт и много воздуха": "Heller Hintergrund, dünne Schrift und viel Luft",
    "Свойство": "Eigenschaft",
    "Свойство {0}": "Eigenschaft {0}",
    "Сделайте снимок или закройте камеру": "Machen Sie ein Foto oder schließen Sie die Kamera",
    "Сетка, выноски и моноширинные цифры": "Raster, Hinweislinien und Ziffern in Festbreite",
    "Сканди": "Skandi",
    "Скачать всё": "Alles herunterladen",
    "Сколько слайдов": "Wie viele Folien",
    "слайд": "Folie",
    "Слайд {0}": "Folie {0}",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Die Folie wurde bereits geändert. Wir haben das Ergebnis aktualisiert — prüfen Sie den Text und speichern Sie erneut.",
    "слайда": "Folien",
    "слайдов": "Folien",
    "слайды": "Folien",
    "Слайды готовы": "Die Folien sind fertig",
    "Слайды ещё загружаются": "Die Folien werden noch geladen",
    "Слайды набора": "Folien des Sets",
    "слайды не созданы": "die Folien wurden nicht erstellt",
    "Слайды с преимуществами": "Vorteilsfolien",
    "Следующий слайд": "Nächste Folie",
    "Собираем слайды": "Folien werden erstellt",
    "Создать {0}": "{0} erstellen",
    "Создать {0} {1} · {2} C": "{0} {1} erstellen · {2} C",
    "Спорт": "Sport",
    "сравнения": "Vergleiche",
    "ссылки, контакты": "Links und Kontakte",
    "Стекло": "Glas",
    "Страна": "Land",
    "строк": "Zeilen",
    "строка": "Zeile",
    "строки": "Zeilen",
    "Текст длиннее {0} знаков": "Der Text ist länger als {0} Zeichen",
    "Текст на слайдах": "Text auf den Folien",
    "Текст набран": "Der Text ist gesetzt",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Der Text passt nicht auf die Folie. Kürzen Sie die Überschrift oder den Text.",
    "Технический": "Technisch",
    "Товар в сцене": "Produkt in Szene",
    "Товар вырезан": "Produkt freigestellt",
    "Тут откроется тема чата, куда бот прислал слайды": "Hier öffnet sich das Chat-Thema, in das der Bot die Folien geschickt hat",
    "Уберите": "Entfernen Sie",
    "Убрать строку {0}": "Zeile {0} entfernen",
    "Удерживайте, чтобы посмотреть все слайды": "Gedrückt halten, um alle Folien zu sehen",
    "Фон готов": "Hintergrund fertig",
    "Фото и текст проверены": "Fotos und Text geprüft",
    "Фото или текст не прошли проверку": "Fotos oder Text haben die Prüfung nicht bestanden",
    "Характеристик уже восемь": "Es gibt schon acht Eigenschaften",
    "Характеристики": "Eigenschaften",
    "Цветная сцена и прозрачные плашки": "Farbige Szene und transparente Felder",
    "Цена": "Preis",
    "Цены, призывы и превосходные степени не возьмём": "Preise, Handlungsaufrufe und Superlative übernehmen wir nicht",
    "цены, скидки": "Preise und Rabatte",
    "Что нашли": "Was wir gefunden haben",
    "шаблон": "Vorlage",
    "шаблона": "Vorlagen",
    "шаблонов": "Vorlagen",
    "Эко": "Öko",
    "Электроника": "Elektronik",
    "Этот вариант пока недоступен": "Diese Variante ist noch nicht verfügbar",
    "Этот слайд больше нельзя изменить.": "Diese Folie kann nicht mehr geändert werden.",
    "Этот слайд нельзя изменить": "Diese Folie kann nicht geändert werden",
    "Я.Маркет": "Y.Market",
    "Яркий": "Kräftig",
    "C за слайд": "C pro Folie",
    "Ozon Fresh принимает обложку только без текста": "Ozon Fresh akzeptiert nur ein Cover ohne Text"
  },
  "fr": {
    "· обложка без надписей": "· couverture sans texte",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1} : {2} n’accepte pas {3} sur les photos",
    "{0}, слайд {1}": "{0}, diapositive {1}",
    "{0}, слайд {1} из {2}": "{0}, diapositive {1} sur {2}",
    "18 × 16 × 8 см": "18 × 16 × 8 cm",
    "250 г": "250 g",
    "40 ч": "40 h",
    "Активное шумоподавление": "Réduction active du bruit",
    "Без надписей": "Sans texte",
    "Беспроводные наушники": "Casque sans fil",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "Le bot les a déjà envoyées dans le chat, dans un sujet à part. Le texte est composé par un modèle, sans fautes d’IA : touchez-le sur une diapositive pour le corriger.",
    "Быстрая зарядка за 10 минут": "Charge rapide en 10 minutes",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "La description ne contient aucun fait sur le produit. Ajoutez des détails.",
    "Вес": "Poids",
    "Видео товара, 5 сек": "Vidéo du produit, 5 s",
    "Возьмём только факты из вашего текста": "Nous ne prendrons que les faits de votre texte",
    "Время работы": "Autonomie",
    "Все оформления": "Tous les styles",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "Collez la description de la fiche ou du fournisseur. Les lignes du type «Poids : 250 g» deviendront des caractéristiques",
    "Вырезаем товар": "Détourage du produit",
    "Главное фото как есть": "La photo principale telle quelle",
    "Главное фото на обложку, остальные в слайды": "La photo principale en couverture, les autres dans les diapositives",
    "Главное фото пойдёт на обложку": "La photo principale ira en couverture",
    "Глубина": "Profondeur",
    "Графит, светлый текст и золотой акцент": "Graphite, texte clair et accent doré",
    "Детали": "Détails",
    "Детский": "Enfants",
    "Детское": "Enfants",
    "Диагонали, жирный курсив и контраст": "Diagonales, italique gras et contraste",
    "До 40 часов без подзарядки": "Jusqu’à 40 heures sans recharge",
    "До 5 ракурсов, главное пойдёт на обложку": "Jusqu’à 5 angles, le principal ira en couverture",
    "Добавить {0}": "Ajouter {0}",
    "Добавить строку": "Ajouter une ligne",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "Ajoutez au texte des propriétés du produit ou des lignes du type «Poids : 250 g»",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "Ajoutez au moins {0} avantages, chacun sur une nouvelle ligne",
    "Дом": "Maison",
    "доставку, возврат": "livraison et retours",
    "другое": "d’autres choses",
    "Еда": "Alimentation",
    "ещё {0}": "{0} de plus",
    "Журнал": "Magazine",
    "за слайд": "par diapositive",
    "Загружаем фото": "Envoi des photos",
    "Загрузите фото товара": "Ajoutez une photo du produit",
    "Заполнить из описания": "Remplir depuis une description",
    "Зарядка": "Charge",
    "заявления об оригинальности": "mentions d’originalité",
    "Значение": "Valeur",
    "Значение {0}": "Valeur {0}",
    "Из фотосессии товара · главное фото на обложке": "De la séance photo du produit · photo principale en couverture",
    "Изменить текст": "Modifier le texte",
    "Искать среди {0} оформлений": "Rechercher parmi {0} styles",
    "К описанию": "Retour à la description",
    "карусель": "carrousel",
    "Ко всем оформлениям": "Vers tous les styles",
    "Комплектация": "Contenu",
    "Красота": "Beauté",
    "Крафт, бежевый и приглушённый зелёный": "Kraft, beige et vert atténué",
    "Круглые формы, тёплый фон и крупные значки": "Formes rondes, fond chaud et grandes icônes",
    "Крупная антиква и свободная вёрстка": "Grand empattement et mise en page aérée",
    "места нет": "plus de place",
    "Минимал": "Minimal",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "Vous pouvez quitter l’écran : le bot vous écrira quand les diapositives seront prêtes.",
    "Мягкие амбушюры": "Coussinets doux",
    "Мягкие амбушюры из эко-кожи": "Coussinets doux en similicuir",
    "Мягкие градиенты и глянцевый подиум": "Dégradés doux et podium brillant",
    "на слайдах": "sur les diapositives",
    "Набираем текст шаблоном": "Composition du texte par modèle",
    "Набираем шрифтом, без ошибок нейросети": "Composé en police, sans fautes d’IA",
    "Нажмите, чтобы выбрать оформление": "Touchez pour choisir un style",
    "Название длиннее {0} знаков": "Le nom dépasse {0} caractères",
    "Название и от {0} преимуществ": "Un nom et au moins {0} avantages",
    "Название и преимущества": "Nom et avantages",
    "Название и преимущество": "Nom et un avantage",
    "Название товара": "Nom du produit",
    "Найти преимущества": "Trouver les avantages",
    "Напишите заголовок или текст": "Écrivez un titre ou un texte",
    "Напишите название товара первой строкой": "Écrivez le nom du produit sur la première ligne",
    "Насыщенный фон и крупные плашки с цифрами": "Fond saturé et grandes pastilles chiffrées",
    "Не взяли {0}: на фото площадки так нельзя": "{0} non retenu : la plateforme ne l’autorise pas sur les photos",
    "Не получилось собрать слайды": "Impossible d’assembler les diapositives",
    "Не удалось перерисовать слайд. Текст остался прежним.": "Impossible de redessiner la diapositive. Le texte reste inchangé.",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "Impossible d’analyser la description. Réessayez.",
    "Нечего добавить, вернитесь к описанию": "Rien à ajouter, revenez à la description",
    "Нужно от {0} знаков описания": "La description doit compter au moins {0} caractères",
    "Об оформлении": "À propos du style",
    "обещания": "promesses",
    "Обложка": "Couverture",
    "Одежда": "Vêtements",
    "Описание длиннее {0} знаков": "La description dépasse {0} caractères",
    "Описание или характеристики": "Description ou caractéristiques",
    "Отметьте, что добавить": "Cochez ce qu’il faut ajouter",
    "Оформление «{0}»": "Style «{0}»",
    "Оформления": "Styles",
    "Пастель": "Pastel",
    "Перед скачиванием уберите": "Avant le téléchargement, retirez",
    "Перерисовываем слайд…": "Redessin de la diapositive…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "Nous redessinerons la diapositive avec le même modèle, sans nouvelle génération.",
    "Подтвердите права на фото": "Confirmez les droits sur les photos",
    "Подтверждаю право использовать фото товара": "Je confirme le droit d’utiliser les photos du produit",
    "Подходит для": "Convient pour",
    "Поиск оформлений": "Rechercher des styles",
    "поместится {0}": "{0} tiendront",
    "Поместится только {0}: снимите другую отметку": "Seulement {0} tiendront : décochez-en un autre",
    "Попробуйте другое слово или сбросьте категорию": "Essayez un autre mot ou réinitialisez la catégorie",
    "Права на фото товара": "Droits sur les photos du produit",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "La modification n’est pas confirmée. Poursuivez la vérification de la même demande.",
    "превосходные степени": "superlatifs",
    "Предыдущий слайд": "Diapositive précédente",
    "Преимуществ до {0}: уберите лишние строки": "Jusqu’à {0} avantages : retirez les lignes en trop",
    "Преимуществ уже шесть: уберите лишнее в форме": "Il y a déjà six avantages : retirez-en dans le formulaire",
    "Преимуществ: {0} из {1}": "Avantages : {0} sur {1}",
    "Преимущество {0}": "Avantage {0}",
    "Преимущество длиннее {0} знаков: сократите строку": "Un avantage dépasse {0} caractères : raccourcissez la ligne",
    "Премиум": "Premium",
    "призывы": "appels à l’action",
    "Проверьте описание: сервер его не принял.": "Vérifiez la description : le serveur ne l’a pas acceptée.",
    "Проверьте текст слайда: сервер его не принял.": "Vérifiez le texte de la diapositive : le serveur ne l’a pas accepté.",
    "Проверяем фото и текст": "Vérification des photos et du texte",
    "Разбор описания пока недоступен. Заполните поле вручную.": "L’analyse de la description n’est pas encore disponible. Remplissez le champ à la main.",
    "Размер": "Taille",
    "Рисуем фон без текста": "Dessin d’un fond sans texte",
    "С надписями": "Avec texte",
    "Светлое дерево и мягкие тени": "Bois clair et ombres douces",
    "Светлый фон, тонкий шрифт и много воздуха": "Fond clair, police fine et beaucoup d’air",
    "Свойство": "Propriété",
    "Свойство {0}": "Propriété {0}",
    "Сделайте снимок или закройте камеру": "Prenez une photo ou fermez l’appareil",
    "Сетка, выноски и моноширинные цифры": "Grille, légendes et chiffres à chasse fixe",
    "Сканди": "Scandi",
    "Скачать всё": "Tout télécharger",
    "Сколько слайдов": "Combien de diapositives",
    "слайд": "diapositive",
    "Слайд {0}": "Diapositive {0}",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "La diapositive a déjà été modifiée. Nous avons actualisé le résultat — vérifiez le texte et enregistrez à nouveau.",
    "слайда": "diapositives",
    "слайдов": "diapositives",
    "слайды": "diapositives",
    "Слайды готовы": "Les diapositives sont prêtes",
    "Слайды ещё загружаются": "Les diapositives sont encore en chargement",
    "Слайды набора": "Diapositives du jeu",
    "слайды не созданы": "les diapositives n’ont pas été créées",
    "Слайды с преимуществами": "Diapositives d’avantages",
    "Следующий слайд": "Diapositive suivante",
    "Собираем слайды": "Assemblage des diapositives",
    "Создать {0}": "Créer {0}",
    "Создать {0} {1} · {2} C": "Créer {0} {1} · {2} C",
    "Спорт": "Sport",
    "сравнения": "comparaisons",
    "ссылки, контакты": "liens et contacts",
    "Стекло": "Verre",
    "Страна": "Pays",
    "строк": "lignes",
    "строка": "ligne",
    "строки": "lignes",
    "Текст длиннее {0} знаков": "Le texte dépasse {0} caractères",
    "Текст на слайдах": "Texte sur les diapositives",
    "Текст набран": "Texte composé",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Le texte ne tient pas sur la diapositive. Raccourcissez le titre ou le texte.",
    "Технический": "Technique",
    "Товар в сцене": "Produit en situation",
    "Товар вырезан": "Produit détouré",
    "Тут откроется тема чата, куда бот прислал слайды": "Ici s’ouvrira le sujet du chat où le bot a envoyé les diapositives",
    "Уберите": "Retirez",
    "Убрать строку {0}": "Retirer la ligne {0}",
    "Удерживайте, чтобы посмотреть все слайды": "Maintenez pour voir toutes les diapositives",
    "Фон готов": "Fond prêt",
    "Фото и текст проверены": "Photos et texte vérifiés",
    "Фото или текст не прошли проверку": "Les photos ou le texte n’ont pas passé la vérification",
    "Характеристик уже восемь": "Il y a déjà huit caractéristiques",
    "Характеристики": "Caractéristiques",
    "Цветная сцена и прозрачные плашки": "Scène colorée et pastilles transparentes",
    "Цена": "Prix",
    "Цены, призывы и превосходные степени не возьмём": "Nous ne prendrons ni prix, ni appels à l’action, ni superlatifs",
    "цены, скидки": "prix et remises",
    "Что нашли": "Ce que nous avons trouvé",
    "шаблон": "modèle",
    "шаблона": "modèles",
    "шаблонов": "modèles",
    "Эко": "Éco",
    "Электроника": "Électronique",
    "Этот вариант пока недоступен": "Cette option n’est pas encore disponible",
    "Этот слайд больше нельзя изменить.": "Cette diapositive ne peut plus être modifiée.",
    "Этот слайд нельзя изменить": "Cette diapositive ne peut pas être modifiée",
    "Я.Маркет": "Y.Market",
    "Яркий": "Éclatant",
    "C за слайд": "C par diapositive",
    "Ozon Fresh принимает обложку только без текста": "Ozon Fresh n’accepte qu’une couverture sans texte"
  },
  "pt": {
    "· обложка без надписей": "· capa sem texto",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1}: {2} não aceita {3} nas fotos",
    "{0}, слайд {1}": "{0}, slide {1}",
    "{0}, слайд {1} из {2}": "{0}, slide {1} de {2}",
    "18 × 16 × 8 см": "18 × 16 × 8 cm",
    "250 г": "250 g",
    "40 ч": "40 h",
    "Активное шумоподавление": "Cancelamento ativo de ruído",
    "Без надписей": "Sem texto",
    "Беспроводные наушники": "Fones de ouvido sem fio",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "O bot já os enviou ao chat, em um tópico separado. O texto é composto por um modelo, sem erros de IA: toque nele em um slide para corrigir.",
    "Быстрая зарядка за 10 минут": "Carregamento rápido em 10 minutos",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "A descrição não tem fatos sobre o produto. Adicione detalhes.",
    "Вес": "Peso",
    "Видео товара, 5 сек": "Vídeo do produto, 5 s",
    "Возьмём только факты из вашего текста": "Vamos usar só os fatos do seu texto",
    "Время работы": "Autonomia",
    "Все оформления": "Todos os designs",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "Cole a descrição do anúncio ou do fornecedor. Linhas como «Peso: 250 g» viram características",
    "Вырезаем товар": "Recortando o produto",
    "Главное фото как есть": "A foto principal como está",
    "Главное фото на обложку, остальные в слайды": "A foto principal vai na capa, as outras nos slides",
    "Главное фото пойдёт на обложку": "A foto principal vai para a capa",
    "Глубина": "Profundidade",
    "Графит, светлый текст и золотой акцент": "Grafite, texto claro e detalhe dourado",
    "Детали": "Detalhes",
    "Детский": "Infantil",
    "Детское": "Infantil",
    "Диагонали, жирный курсив и контраст": "Diagonais, itálico em negrito e contraste",
    "До 40 часов без подзарядки": "Até 40 horas sem recarregar",
    "До 5 ракурсов, главное пойдёт на обложку": "Até 5 ângulos, o principal vai para a capa",
    "Добавить {0}": "Adicionar {0}",
    "Добавить строку": "Adicionar linha",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "Adicione ao texto propriedades do produto ou linhas como «Peso: 250 g»",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "Adicione pelo menos {0} benefícios, cada um em uma linha",
    "Дом": "Casa",
    "доставку, возврат": "entrega e devolução",
    "другое": "outras coisas",
    "Еда": "Comida",
    "ещё {0}": "mais {0}",
    "Журнал": "Revista",
    "за слайд": "por slide",
    "Загружаем фото": "Enviando fotos",
    "Загрузите фото товара": "Envie uma foto do produto",
    "Заполнить из описания": "Preencher pela descrição",
    "Зарядка": "Carregamento",
    "заявления об оригинальности": "alegações de originalidade",
    "Значение": "Valor",
    "Значение {0}": "Valor {0}",
    "Из фотосессии товара · главное фото на обложке": "Do ensaio do produto · foto principal na capa",
    "Изменить текст": "Editar texto",
    "Искать среди {0} оформлений": "Buscar entre {0} designs",
    "К описанию": "Para a descrição",
    "карусель": "carrossel",
    "Ко всем оформлениям": "Para todos os designs",
    "Комплектация": "Conteúdo",
    "Красота": "Beleza",
    "Крафт, бежевый и приглушённый зелёный": "Kraft, bege e verde suave",
    "Круглые формы, тёплый фон и крупные значки": "Formas arredondadas, fundo quente e ícones grandes",
    "Крупная антиква и свободная вёрстка": "Serifa grande e diagramação livre",
    "места нет": "sem espaço",
    "Минимал": "Minimal",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "Você pode sair da tela: o bot avisa quando os slides estiverem prontos.",
    "Мягкие амбушюры": "Almofadas macias",
    "Мягкие амбушюры из эко-кожи": "Almofadas macias de couro ecológico",
    "Мягкие градиенты и глянцевый подиум": "Degradês suaves e pódio brilhante",
    "на слайдах": "nos slides",
    "Набираем текст шаблоном": "Compondo o texto com modelo",
    "Набираем шрифтом, без ошибок нейросети": "Composto em fonte, sem erros de IA",
    "Нажмите, чтобы выбрать оформление": "Toque para escolher um design",
    "Название длиннее {0} знаков": "O nome tem mais de {0} caracteres",
    "Название и от {0} преимуществ": "Nome e pelo menos {0} benefícios",
    "Название и преимущества": "Nome e benefícios",
    "Название и преимущество": "Nome e um benefício",
    "Название товара": "Nome do produto",
    "Найти преимущества": "Encontrar benefícios",
    "Напишите заголовок или текст": "Escreva um título ou um texto",
    "Напишите название товара первой строкой": "Escreva o nome do produto na primeira linha",
    "Насыщенный фон и крупные плашки с цифрами": "Fundo intenso e grandes blocos com números",
    "Не взяли {0}: на фото площадки так нельзя": "{0} não foi usado: a plataforma não permite isso nas fotos",
    "Не получилось собрать слайды": "Não foi possível montar os slides",
    "Не удалось перерисовать слайд. Текст остался прежним.": "Não foi possível redesenhar o slide. O texto continua o mesmo.",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "Não foi possível analisar a descrição. Tente novamente.",
    "Нечего добавить, вернитесь к описанию": "Nada para adicionar, volte à descrição",
    "Нужно от {0} знаков описания": "A descrição precisa de pelo menos {0} caracteres",
    "Об оформлении": "Sobre o design",
    "обещания": "promessas",
    "Обложка": "Capa",
    "Одежда": "Roupas",
    "Описание длиннее {0} знаков": "A descrição tem mais de {0} caracteres",
    "Описание или характеристики": "Descrição ou características",
    "Отметьте, что добавить": "Marque o que adicionar",
    "Оформление «{0}»": "Design «{0}»",
    "Оформления": "Designs",
    "Пастель": "Pastel",
    "Перед скачиванием уберите": "Antes de baixar, remova",
    "Перерисовываем слайд…": "Redesenhando o slide…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "Vamos redesenhar o slide com o mesmo modelo, sem nova geração.",
    "Подтвердите права на фото": "Confirme os direitos sobre as fotos",
    "Подтверждаю право использовать фото товара": "Confirmo o direito de usar as fotos do produto",
    "Подходит для": "Combina com",
    "Поиск оформлений": "Buscar designs",
    "поместится {0}": "cabem {0}",
    "Поместится только {0}: снимите другую отметку": "Só cabem {0}: desmarque outro item",
    "Попробуйте другое слово или сбросьте категорию": "Tente outra palavra ou limpe a categoria",
    "Права на фото товара": "Direitos sobre as fotos do produto",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "A edição não foi confirmada. Continue verificando o mesmo pedido.",
    "превосходные степени": "superlativos",
    "Предыдущий слайд": "Slide anterior",
    "Преимуществ до {0}: уберите лишние строки": "Até {0} benefícios: remova as linhas a mais",
    "Преимуществ уже шесть: уберите лишнее в форме": "Já há seis benefícios: remova algum no formulário",
    "Преимуществ: {0} из {1}": "Benefícios: {0} de {1}",
    "Преимущество {0}": "Benefício {0}",
    "Преимущество длиннее {0} знаков: сократите строку": "Um benefício tem mais de {0} caracteres: encurte a linha",
    "Премиум": "Premium",
    "призывы": "chamadas para ação",
    "Проверьте описание: сервер его не принял.": "Verifique a descrição: o servidor não a aceitou.",
    "Проверьте текст слайда: сервер его не принял.": "Verifique o texto do slide: o servidor não o aceitou.",
    "Проверяем фото и текст": "Verificando as fotos e o texto",
    "Разбор описания пока недоступен. Заполните поле вручную.": "A análise da descrição ainda não está disponível. Preencha o campo manualmente.",
    "Размер": "Tamanho",
    "Рисуем фон без текста": "Desenhando um fundo sem texto",
    "С надписями": "Com texto",
    "Светлое дерево и мягкие тени": "Madeira clara e sombras suaves",
    "Светлый фон, тонкий шрифт и много воздуха": "Fundo claro, fonte fina e muito respiro",
    "Свойство": "Propriedade",
    "Свойство {0}": "Propriedade {0}",
    "Сделайте снимок или закройте камеру": "Tire uma foto ou feche a câmera",
    "Сетка, выноски и моноширинные цифры": "Grade, chamadas e números monoespaçados",
    "Сканди": "Escandi",
    "Скачать всё": "Baixar tudo",
    "Сколько слайдов": "Quantos slides",
    "слайд": "slide",
    "Слайд {0}": "Slide {0}",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "O slide já foi alterado. Atualizamos o resultado — confira o texto e salve de novo.",
    "слайда": "slides",
    "слайдов": "slides",
    "слайды": "slides",
    "Слайды готовы": "Os slides estão prontos",
    "Слайды ещё загружаются": "Os slides ainda estão carregando",
    "Слайды набора": "Slides do conjunto",
    "слайды не созданы": "os slides não foram criados",
    "Слайды с преимуществами": "Slides de benefícios",
    "Следующий слайд": "Próximo slide",
    "Собираем слайды": "Montando os slides",
    "Создать {0}": "Criar {0}",
    "Создать {0} {1} · {2} C": "Criar {0} {1} · {2} C",
    "Спорт": "Esporte",
    "сравнения": "comparações",
    "ссылки, контакты": "links e contatos",
    "Стекло": "Vidro",
    "Страна": "País",
    "строк": "linhas",
    "строка": "linha",
    "строки": "linhas",
    "Текст длиннее {0} знаков": "O texto tem mais de {0} caracteres",
    "Текст на слайдах": "Texto nos slides",
    "Текст набран": "Texto composto",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "O texto não cabe no slide. Encurte o título ou o texto.",
    "Технический": "Técnico",
    "Товар в сцене": "Produto em cena",
    "Товар вырезан": "Produto recortado",
    "Тут откроется тема чата, куда бот прислал слайды": "Aqui vai abrir o tópico do chat onde o bot enviou os slides",
    "Уберите": "Remova",
    "Убрать строку {0}": "Remover linha {0}",
    "Удерживайте, чтобы посмотреть все слайды": "Segure para ver todos os slides",
    "Фон готов": "Fundo pronto",
    "Фото и текст проверены": "Fotos e texto verificados",
    "Фото или текст не прошли проверку": "As fotos ou o texto não passaram na verificação",
    "Характеристик уже восемь": "Já há oito características",
    "Характеристики": "Características",
    "Цветная сцена и прозрачные плашки": "Cena colorida e blocos transparentes",
    "Цена": "Preço",
    "Цены, призывы и превосходные степени не возьмём": "Não vamos usar preços, chamadas para ação nem superlativos",
    "цены, скидки": "preços e descontos",
    "Что нашли": "O que encontramos",
    "шаблон": "modelo",
    "шаблона": "modelos",
    "шаблонов": "modelos",
    "Эко": "Eco",
    "Электроника": "Eletrônicos",
    "Этот вариант пока недоступен": "Esta opção ainda não está disponível",
    "Этот слайд больше нельзя изменить.": "Este slide não pode mais ser editado.",
    "Этот слайд нельзя изменить": "Este slide não pode ser editado",
    "Я.Маркет": "Y.Market",
    "Яркий": "Vibrante",
    "C за слайд": "C por slide",
    "Ozon Fresh принимает обложку только без текста": "A Ozon Fresh só aceita capa sem texto"
  },
  "tr": {
    "· обложка без надписей": "· metinsiz kapak",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1}: {2} fotoğraflarda {3} kabul etmez",
    "{0}, слайд {1}": "{0}, slayt {1}",
    "{0}, слайд {1} из {2}": "{0}, slayt {1}/{2}",
    "18 × 16 × 8 см": "18 × 16 × 8 cm",
    "250 г": "250 g",
    "40 ч": "40 sa",
    "Активное шумоподавление": "Aktif gürültü engelleme",
    "Без надписей": "Metinsiz",
    "Беспроводные наушники": "Kablosuz kulaklık",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "Bot bunları sohbete ayrı bir konuda gönderdi. Metin şablonla dizildi, yapay zekâ hatası yok: düzeltmek için slayttaki metne dokunun.",
    "Быстрая зарядка за 10 минут": "10 dakikada hızlı şarj",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "Açıklamada ürüne dair bilgi bulunamadı. Ayrıntı ekleyin.",
    "Вес": "Ağırlık",
    "Видео товара, 5 сек": "Ürün videosu, 5 sn",
    "Возьмём только факты из вашего текста": "Yalnızca metninizdeki bilgileri alacağız",
    "Время работы": "Çalışma süresi",
    "Все оформления": "Tüm tasarımlar",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "Ürün kartındaki ya da tedarikçinin açıklamasını yapıştırın. «Ağırlık: 250 g» gibi satırlar özelliğe dönüşür",
    "Вырезаем товар": "Ürün kesiliyor",
    "Главное фото как есть": "Ana fotoğraf olduğu gibi",
    "Главное фото на обложку, остальные в слайды": "Ana fotoğraf kapağa, diğerleri slaytlara",
    "Главное фото пойдёт на обложку": "Ana fotoğraf kapağa gelecek",
    "Глубина": "Derinlik",
    "Графит, светлый текст и золотой акцент": "Grafit, açık renk metin ve altın vurgu",
    "Детали": "Ayrıntılar",
    "Детский": "Çocuk",
    "Детское": "Çocuk",
    "Диагонали, жирный курсив и контраст": "Çaprazlar, kalın italik ve kontrast",
    "До 40 часов без подзарядки": "Şarj etmeden 40 saate kadar",
    "До 5 ракурсов, главное пойдёт на обложку": "En fazla 5 açı, ana açı kapağa gelecek",
    "Добавить {0}": "{0} ekle",
    "Добавить строку": "Satır ekle",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "Metne ürün özellikleri ya da «Ağırlık: 250 g» gibi satırlar ekleyin",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "Her biri yeni satırda olmak üzere en az {0} avantaj ekleyin",
    "Дом": "Ev",
    "доставку, возврат": "teslimat ve iade",
    "другое": "diğer şeyler",
    "Еда": "Gıda",
    "ещё {0}": "{0} tane daha",
    "Журнал": "Dergi",
    "за слайд": "slayt başına",
    "Загружаем фото": "Fotoğraflar yükleniyor",
    "Загрузите фото товара": "Ürün fotoğrafı yükleyin",
    "Заполнить из описания": "Açıklamadan doldur",
    "Зарядка": "Şarj",
    "заявления об оригинальности": "orijinallik iddiaları",
    "Значение": "Değer",
    "Значение {0}": "Değer {0}",
    "Из фотосессии товара · главное фото на обложке": "Ürün çekiminden · ana fotoğraf kapakta",
    "Изменить текст": "Metni düzenle",
    "Искать среди {0} оформлений": "{0} tasarım arasında ara",
    "К описанию": "Açıklamaya dön",
    "карусель": "karusel",
    "Ко всем оформлениям": "Tüm tasarımlara",
    "Комплектация": "Paket içeriği",
    "Красота": "Güzellik",
    "Крафт, бежевый и приглушённый зелёный": "Kraft, bej ve soluk yeşil",
    "Круглые формы, тёплый фон и крупные значки": "Yuvarlak şekiller, sıcak arka plan ve büyük simgeler",
    "Крупная антиква и свободная вёрстка": "Büyük serifli yazı ve ferah düzen",
    "места нет": "yer yok",
    "Минимал": "Minimal",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "Ekrandan çıkabilirsiniz: slaytlar hazır olunca bot yazacak.",
    "Мягкие амбушюры": "Yumuşak kulak yastıkları",
    "Мягкие амбушюры из эко-кожи": "Yumuşak eko deri kulak yastıkları",
    "Мягкие градиенты и глянцевый подиум": "Yumuşak geçişler ve parlak podyum",
    "на слайдах": "slaytlarda",
    "Набираем текст шаблоном": "Metin şablonla diziliyor",
    "Набираем шрифтом, без ошибок нейросети": "Yazı tipiyle dizilir, yapay zekâ hatası olmaz",
    "Нажмите, чтобы выбрать оформление": "Tasarım seçmek için dokunun",
    "Название длиннее {0} знаков": "Ad {0} karakterden uzun",
    "Название и от {0} преимуществ": "Ad ve en az {0} avantaj",
    "Название и преимущества": "Ad ve avantajlar",
    "Название и преимущество": "Ad ve bir avantaj",
    "Название товара": "Ürün adı",
    "Найти преимущества": "Avantajları bul",
    "Напишите заголовок или текст": "Bir başlık ya da metin yazın",
    "Напишите название товара первой строкой": "Ürün adını ilk satıra yazın",
    "Насыщенный фон и крупные плашки с цифрами": "Canlı arka plan ve büyük numaralı kutular",
    "Не взяли {0}: на фото площадки так нельзя": "{0} alınmadı: platform fotoğraflarda buna izin vermiyor",
    "Не получилось собрать слайды": "Slaytlar oluşturulamadı",
    "Не удалось перерисовать слайд. Текст остался прежним.": "Slayt yeniden çizilemedi. Metin aynı kaldı.",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "Açıklama çözümlenemedi. Yeniden deneyin.",
    "Нечего добавить, вернитесь к описанию": "Eklenecek bir şey yok, açıklamaya dönün",
    "Нужно от {0} знаков описания": "Açıklama en az {0} karakter olmalı",
    "Об оформлении": "Tasarım hakkında",
    "обещания": "vaatler",
    "Обложка": "Kapak",
    "Одежда": "Giyim",
    "Описание длиннее {0} знаков": "Açıklama {0} karakterden uzun",
    "Описание или характеристики": "Açıklama ya da özellikler",
    "Отметьте, что добавить": "Neyin ekleneceğini işaretleyin",
    "Оформление «{0}»": "«{0}» tasarımı",
    "Оформления": "Tasarımlar",
    "Пастель": "Pastel",
    "Перед скачиванием уберите": "İndirmeden önce kaldırın",
    "Перерисовываем слайд…": "Slayt yeniden çiziliyor…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "Slaytı aynı şablonla, yeni üretim yapmadan yeniden çizeceğiz.",
    "Подтвердите права на фото": "Fotoğraf haklarını onaylayın",
    "Подтверждаю право использовать фото товара": "Ürün fotoğraflarını kullanma hakkımı onaylıyorum",
    "Подходит для": "Uygun olduğu",
    "Поиск оформлений": "Tasarım ara",
    "поместится {0}": "{0} sığar",
    "Поместится только {0}: снимите другую отметку": "Yalnızca {0} sığar: başka bir işareti kaldırın",
    "Попробуйте другое слово или сбросьте категорию": "Başka bir kelime deneyin ya da kategoriyi sıfırlayın",
    "Права на фото товара": "Ürün fotoğraflarının hakları",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Düzenleme onaylanmadı. Aynı isteği denetlemeye devam edin.",
    "превосходные степени": "üstünlük ifadeleri",
    "Предыдущий слайд": "Önceki slayt",
    "Преимуществ до {0}: уберите лишние строки": "En fazla {0} avantaj: fazla satırları kaldırın",
    "Преимуществ уже шесть: уберите лишнее в форме": "Zaten altı avantaj var: formdan fazlalığı kaldırın",
    "Преимуществ: {0} из {1}": "Avantajlar: {0}/{1}",
    "Преимущество {0}": "Avantaj {0}",
    "Преимущество длиннее {0} знаков: сократите строку": "Bir avantaj {0} karakterden uzun: satırı kısaltın",
    "Премиум": "Premium",
    "призывы": "harekete geçirici çağrılar",
    "Проверьте описание: сервер его не принял.": "Açıklamayı kontrol edin: sunucu kabul etmedi.",
    "Проверьте текст слайда: сервер его не принял.": "Slayt metnini kontrol edin: sunucu kabul etmedi.",
    "Проверяем фото и текст": "Fotoğraflar ve metin denetleniyor",
    "Разбор описания пока недоступен. Заполните поле вручную.": "Açıklama çözümleme henüz kullanılamıyor. Alanı elle doldurun.",
    "Размер": "Boyut",
    "Рисуем фон без текста": "Metinsiz arka plan çiziliyor",
    "С надписями": "Metinli",
    "Светлое дерево и мягкие тени": "Açık ahşap ve yumuşak gölgeler",
    "Светлый фон, тонкий шрифт и много воздуха": "Açık arka plan, ince yazı tipi ve bolca boşluk",
    "Свойство": "Özellik",
    "Свойство {0}": "Özellik {0}",
    "Сделайте снимок или закройте камеру": "Fotoğraf çekin ya da kamerayı kapatın",
    "Сетка, выноски и моноширинные цифры": "Izgara, açıklama çizgileri ve eş aralıklı rakamlar",
    "Сканди": "İskandinav",
    "Скачать всё": "Tümünü indir",
    "Сколько слайдов": "Kaç slayt",
    "слайд": "slayt",
    "Слайд {0}": "Slayt {0}",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Slayt zaten değiştirildi. Sonucu yeniledik — metni kontrol edip yeniden kaydedin.",
    "слайда": "slayt",
    "слайдов": "slayt",
    "слайды": "slaytları",
    "Слайды готовы": "Slaytlar hazır",
    "Слайды ещё загружаются": "Slaytlar hâlâ yükleniyor",
    "Слайды набора": "Setteki slaytlar",
    "слайды не созданы": "slaytlar oluşturulmadı",
    "Слайды с преимуществами": "Avantaj slaytları",
    "Следующий слайд": "Sonraki slayt",
    "Собираем слайды": "Slaytlar oluşturuluyor",
    "Создать {0}": "{0} oluştur",
    "Создать {0} {1} · {2} C": "{0} {1} oluştur · {2} C",
    "Спорт": "Spor",
    "сравнения": "karşılaştırmalar",
    "ссылки, контакты": "bağlantılar ve iletişim bilgileri",
    "Стекло": "Cam",
    "Страна": "Ülke",
    "строк": "satır",
    "строка": "satır",
    "строки": "satır",
    "Текст длиннее {0} знаков": "Metin {0} karakterden uzun",
    "Текст на слайдах": "Slaytlardaki metin",
    "Текст набран": "Metin dizildi",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Metin slayta sığmıyor. Başlığı ya da metni kısaltın.",
    "Технический": "Teknik",
    "Товар в сцене": "Sahnede ürün",
    "Товар вырезан": "Ürün kesildi",
    "Тут откроется тема чата, куда бот прислал слайды": "Botun slaytları gönderdiği sohbet konusu burada açılacak",
    "Уберите": "Kaldırın",
    "Убрать строку {0}": "{0}. satırı kaldır",
    "Удерживайте, чтобы посмотреть все слайды": "Tüm slaytları görmek için basılı tutun",
    "Фон готов": "Arka plan hazır",
    "Фото и текст проверены": "Fotoğraflar ve metin denetlendi",
    "Фото или текст не прошли проверку": "Fotoğraflar ya da metin denetimden geçmedi",
    "Характеристик уже восемь": "Zaten sekiz özellik var",
    "Характеристики": "Özellikler",
    "Цветная сцена и прозрачные плашки": "Renkli sahne ve saydam kutular",
    "Цена": "Fiyat",
    "Цены, призывы и превосходные степени не возьмём": "Fiyatları, çağrıları ve üstünlük ifadelerini almayacağız",
    "цены, скидки": "fiyatlar ve indirimler",
    "Что нашли": "Bulunanlar",
    "шаблон": "şablon",
    "шаблона": "şablon",
    "шаблонов": "şablon",
    "Эко": "Eko",
    "Электроника": "Elektronik",
    "Этот вариант пока недоступен": "Bu seçenek henüz kullanılamıyor",
    "Этот слайд больше нельзя изменить.": "Bu slayt artık düzenlenemez.",
    "Этот слайд нельзя изменить": "Bu slayt düzenlenemez",
    "Я.Маркет": "Y.Market",
    "Яркий": "Canlı",
    "C за слайд": "C / slayt",
    "Ozon Fresh принимает обложку только без текста": "Ozon Fresh yalnızca metinsiz kapak kabul eder"
  },
  "kk": {
    "· обложка без надписей": "· жазусыз мұқаба",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1}: {2} фотода {3} қабылдамайды",
    "{0}, слайд {1}": "{0}, {1}-слайд",
    "{0}, слайд {1} из {2}": "{0}, {2} ішінен {1}-слайд",
    "18 × 16 × 8 см": "18 × 16 × 8 см",
    "250 г": "250 г",
    "40 ч": "40 сағ",
    "Активное шумоподавление": "Белсенді шуды басу",
    "Без надписей": "Жазусыз",
    "Беспроводные наушники": "Сымсыз құлаққап",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "Бот оларды чатқа бөлек тақырыппен жіберді. Мәтін үлгімен терілген, нейрожелі қателері жоқ: түзету үшін слайдтағы мәтінді түртіңіз.",
    "Быстрая зарядка за 10 минут": "10 минутта жылдам зарядтау",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "Сипаттамада тауар туралы дерек табылмады. Толығырақ жазыңыз.",
    "Вес": "Салмағы",
    "Видео товара, 5 сек": "Тауар бейнесі, 5 сек",
    "Возьмём только факты из вашего текста": "Мәтініңізден тек деректерді аламыз",
    "Время работы": "Жұмыс уақыты",
    "Все оформления": "Барлық безендірулер",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "Тауар карточкасынан не жеткізушіден сипаттаманы қойыңыз. «Салмағы: 250 г» сияқты жолдар сипаттамаға айналады",
    "Вырезаем товар": "Тауарды қиып аламыз",
    "Главное фото как есть": "Негізгі фото өзгеріссіз",
    "Главное фото на обложку, остальные в слайды": "Негізгі фото мұқабаға, қалғаны слайдтарға",
    "Главное фото пойдёт на обложку": "Негізгі фото мұқабаға шығады",
    "Глубина": "Тереңдігі",
    "Графит, светлый текст и золотой акцент": "Графит, ашық мәтін және алтын екпін",
    "Детали": "Бөлшектер",
    "Детский": "Балалар",
    "Детское": "Балалар",
    "Диагонали, жирный курсив и контраст": "Диагональдар, жуан көлбеу қаріп және контраст",
    "До 40 часов без подзарядки": "Зарядсыз 40 сағатқа дейін",
    "До 5 ракурсов, главное пойдёт на обложку": "5 ракурсқа дейін, негізгісі мұқабаға шығады",
    "Добавить {0}": "{0} қосу",
    "Добавить строку": "Жол қосу",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "Мәтінге тауар қасиеттерін немесе «Салмағы: 250 г» сияқты жолдарды қосыңыз",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "Кемінде {0} артықшылық қосыңыз, әрқайсысын жаңа жолдан",
    "Дом": "Үй",
    "доставку, возврат": "жеткізу мен қайтару",
    "другое": "басқасын",
    "Еда": "Тағам",
    "ещё {0}": "тағы {0}",
    "Журнал": "Журнал",
    "за слайд": "бір слайд үшін",
    "Загружаем фото": "Фото жүктеліп жатыр",
    "Загрузите фото товара": "Тауар фотосын жүктеңіз",
    "Заполнить из описания": "Сипаттамадан толтыру",
    "Зарядка": "Зарядтау",
    "заявления об оригинальности": "түпнұсқалық туралы мәлімдемелер",
    "Значение": "Мәні",
    "Значение {0}": "{0}-мән",
    "Из фотосессии товара · главное фото на обложке": "Тауар фотосессиясынан · негізгі фото мұқабада",
    "Изменить текст": "Мәтінді өзгерту",
    "Искать среди {0} оформлений": "{0} безендіру арасынан іздеу",
    "К описанию": "Сипаттамаға",
    "карусель": "карусель",
    "Ко всем оформлениям": "Барлық безендіруге",
    "Комплектация": "Жиынтық",
    "Красота": "Сұлулық",
    "Крафт, бежевый и приглушённый зелёный": "Крафт, беж және күңгірт жасыл",
    "Круглые формы, тёплый фон и крупные значки": "Дөңгелек пішіндер, жылы фон және ірі белгішелер",
    "Крупная антиква и свободная вёрстка": "Ірі антиква және еркін беттеу",
    "места нет": "орын жоқ",
    "Минимал": "Минимал",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "Экраннан шыға беруге болады: слайдтар дайын болғанда бот жазады.",
    "Мягкие амбушюры": "Жұмсақ жастықшалар",
    "Мягкие амбушюры из эко-кожи": "Эко-былғарыдан жасалған жұмсақ жастықшалар",
    "Мягкие градиенты и глянцевый подиум": "Жұмсақ градиенттер және жылтыр подиум",
    "на слайдах": "слайдтарда",
    "Набираем текст шаблоном": "Мәтінді үлгімен тереміз",
    "Набираем шрифтом, без ошибок нейросети": "Қаріппен терілген, нейрожелі қателерінсіз",
    "Нажмите, чтобы выбрать оформление": "Безендіруді таңдау үшін түртіңіз",
    "Название длиннее {0} знаков": "Атауы {0} таңбадан ұзын",
    "Название и от {0} преимуществ": "Атауы және кемінде {0} артықшылық",
    "Название и преимущества": "Атауы және артықшылықтары",
    "Название и преимущество": "Атауы және артықшылығы",
    "Название товара": "Тауар атауы",
    "Найти преимущества": "Артықшылықтарды табу",
    "Напишите заголовок или текст": "Тақырып немесе мәтін жазыңыз",
    "Напишите название товара первой строкой": "Тауар атауын бірінші жолға жазыңыз",
    "Насыщенный фон и крупные плашки с цифрами": "Қанық фон және цифрлары бар ірі тақташалар",
    "Не взяли {0}: на фото площадки так нельзя": "{0} алынбады: алаң фотосында бұған болмайды",
    "Не получилось собрать слайды": "Слайдтарды жинау мүмкін болмады",
    "Не удалось перерисовать слайд. Текст остался прежним.": "Слайдты қайта салу мүмкін болмады. Мәтін бұрынғыдай қалды.",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "Сипаттаманы талдау мүмкін болмады. Қайталап көріңіз.",
    "Нечего добавить, вернитесь к описанию": "Қосатын ештеңе жоқ, сипаттамаға оралыңыз",
    "Нужно от {0} знаков описания": "Сипаттама кемінде {0} таңба болуы керек",
    "Об оформлении": "Безендіру туралы",
    "обещания": "уәделер",
    "Обложка": "Мұқаба",
    "Одежда": "Киім",
    "Описание длиннее {0} знаков": "Сипаттама {0} таңбадан ұзын",
    "Описание или характеристики": "Сипаттама немесе сипаттамалар",
    "Отметьте, что добавить": "Нені қосатынын белгілеңіз",
    "Оформление «{0}»": "«{0}» безендіруі",
    "Оформления": "Безендірулер",
    "Пастель": "Пастель",
    "Перед скачиванием уберите": "Жүктеп алмас бұрын алып тастаңыз",
    "Перерисовываем слайд…": "Слайдты қайта саламыз…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "Слайдты сол үлгімен, жаңа генерациясыз қайта саламыз.",
    "Подтвердите права на фото": "Фотоға құқықты растаңыз",
    "Подтверждаю право использовать фото товара": "Тауар фотосын пайдалану құқығын растаймын",
    "Подходит для": "Қандай тауарға",
    "Поиск оформлений": "Безендіру іздеу",
    "поместится {0}": "{0} сыяды",
    "Поместится только {0}: снимите другую отметку": "Тек {0} сыяды: басқа белгіні алыңыз",
    "Попробуйте другое слово или сбросьте категорию": "Басқа сөзді көріңіз немесе санатты алып тастаңыз",
    "Права на фото товара": "Тауар фотосына құқық",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Түзету расталмады. Сол сұрауды тексеруді жалғастырыңыз.",
    "превосходные степени": "асырмалы шырай",
    "Предыдущий слайд": "Алдыңғы слайд",
    "Преимуществ до {0}: уберите лишние строки": "Артықшылық {0}-ге дейін: артық жолдарды алыңыз",
    "Преимуществ уже шесть: уберите лишнее в форме": "Артықшылық алтау болды: формадан артығын алыңыз",
    "Преимуществ: {0} из {1}": "Артықшылықтар: {1} ішінен {0}",
    "Преимущество {0}": "{0}-артықшылық",
    "Преимущество длиннее {0} знаков: сократите строку": "Артықшылық {0} таңбадан ұзын: жолды қысқартыңыз",
    "Премиум": "Премиум",
    "призывы": "үндеулер",
    "Проверьте описание: сервер его не принял.": "Сипаттаманы тексеріңіз: сервер оны қабылдамады.",
    "Проверьте текст слайда: сервер его не принял.": "Слайд мәтінін тексеріңіз: сервер оны қабылдамады.",
    "Проверяем фото и текст": "Фото мен мәтінді тексереміз",
    "Разбор описания пока недоступен. Заполните поле вручную.": "Сипаттаманы талдау әзірге қолжетімсіз. Өрісті қолмен толтырыңыз.",
    "Размер": "Өлшемі",
    "Рисуем фон без текста": "Мәтінсіз фон саламыз",
    "С надписями": "Жазулы",
    "Светлое дерево и мягкие тени": "Ашық ағаш және жұмсақ көлеңкелер",
    "Светлый фон, тонкий шрифт и много воздуха": "Ашық фон, жіңішке қаріп және кең кеңістік",
    "Свойство": "Қасиеті",
    "Свойство {0}": "{0}-қасиет",
    "Сделайте снимок или закройте камеру": "Суретке түсіріңіз немесе камераны жабыңыз",
    "Сетка, выноски и моноширинные цифры": "Тор, сілтемелер және бірдей енді цифрлар",
    "Сканди": "Сканди",
    "Скачать всё": "Барлығын жүктеп алу",
    "Сколько слайдов": "Неше слайд",
    "слайд": "слайд",
    "Слайд {0}": "{0}-слайд",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Слайд өзгертіліп қойған. Нәтижені жаңарттық — мәтінді тексеріп, қайта сақтаңыз.",
    "слайда": "слайд",
    "слайдов": "слайд",
    "слайды": "слайдтарды",
    "Слайды готовы": "Слайдтар дайын",
    "Слайды ещё загружаются": "Слайдтар әлі жүктеліп жатыр",
    "Слайды набора": "Жинақ слайдтары",
    "слайды не созданы": "слайдтар жасалмады",
    "Слайды с преимуществами": "Артықшылықтар слайдтары",
    "Следующий слайд": "Келесі слайд",
    "Собираем слайды": "Слайдтарды жинаймыз",
    "Создать {0}": "{0} жасау",
    "Создать {0} {1} · {2} C": "{0} {1} жасау · {2} C",
    "Спорт": "Спорт",
    "сравнения": "салыстырулар",
    "ссылки, контакты": "сілтемелер мен байланыстар",
    "Стекло": "Шыны",
    "Страна": "Елі",
    "строк": "жол",
    "строка": "жол",
    "строки": "жол",
    "Текст длиннее {0} знаков": "Мәтін {0} таңбадан ұзын",
    "Текст на слайдах": "Слайдтардағы мәтін",
    "Текст набран": "Мәтін терілді",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Мәтін слайдқа сыймайды. Тақырыпты немесе мәтінді қысқартыңыз.",
    "Технический": "Техникалық",
    "Товар в сцене": "Сахнадағы тауар",
    "Товар вырезан": "Тауар қиылды",
    "Тут откроется тема чата, куда бот прислал слайды": "Мұнда бот слайдтарды жіберген чат тақырыбы ашылады",
    "Уберите": "Алып тастаңыз",
    "Убрать строку {0}": "{0}-жолды алып тастау",
    "Удерживайте, чтобы посмотреть все слайды": "Барлық слайдты көру үшін басып тұрыңыз",
    "Фон готов": "Фон дайын",
    "Фото и текст проверены": "Фото мен мәтін тексерілді",
    "Фото или текст не прошли проверку": "Фото немесе мәтін тексеруден өтпеді",
    "Характеристик уже восемь": "Сипаттама сегізу болды",
    "Характеристики": "Сипаттамалар",
    "Цветная сцена и прозрачные плашки": "Түрлі түсті сахна және мөлдір тақташалар",
    "Цена": "Бағасы",
    "Цены, призывы и превосходные степени не возьмём": "Бағаларды, үндеулерді және асырмалы шырайды алмаймыз",
    "цены, скидки": "бағалар мен жеңілдіктер",
    "Что нашли": "Не таптық",
    "шаблон": "үлгі",
    "шаблона": "үлгі",
    "шаблонов": "үлгі",
    "Эко": "Эко",
    "Электроника": "Электроника",
    "Этот вариант пока недоступен": "Бұл нұсқа әзірге қолжетімсіз",
    "Этот слайд больше нельзя изменить.": "Бұл слайдты енді өзгерту мүмкін емес.",
    "Этот слайд нельзя изменить": "Бұл слайдты өзгерту мүмкін емес",
    "Я.Маркет": "Я.Маркет",
    "Яркий": "Жарқын",
    "C за слайд": "C / слайд",
    "Ozon Fresh принимает обложку только без текста": "Ozon Fresh тек мәтінсіз мұқабаны қабылдайды"
  },
  "uk": {
    "· обложка без надписей": "· обкладинка без написів",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1}: {2} не приймає на фото {3}",
    "{0}, слайд {1}": "{0}, слайд {1}",
    "{0}, слайд {1} из {2}": "{0}, слайд {1} з {2}",
    "18 × 16 × 8 см": "18 × 16 × 8 см",
    "250 г": "250 г",
    "40 ч": "40 год",
    "Активное шумоподавление": "Активне шумозаглушення",
    "Без надписей": "Без написів",
    "Беспроводные наушники": "Бездротові навушники",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "Бот уже надіслав їх у чат, в окрему тему. Текст набрано шаблоном, без помилок нейромережі: натисніть на нього на слайді, щоб виправити.",
    "Быстрая зарядка за 10 минут": "Швидка зарядка за 10 хвилин",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "В описі немає фактів про товар. Додайте подробиці.",
    "Вес": "Вага",
    "Видео товара, 5 сек": "Відео товару, 5 с",
    "Возьмём только факты из вашего текста": "Візьмемо лише факти з вашого тексту",
    "Время работы": "Час роботи",
    "Все оформления": "Усі оформлення",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "Вставте опис із картки або від постачальника. Рядки на кшталт «Вага: 250 г» стануть характеристиками",
    "Вырезаем товар": "Вирізаємо товар",
    "Главное фото как есть": "Головне фото як є",
    "Главное фото на обложку, остальные в слайды": "Головне фото на обкладинку, решта — у слайди",
    "Главное фото пойдёт на обложку": "Головне фото піде на обкладинку",
    "Глубина": "Глибина",
    "Графит, светлый текст и золотой акцент": "Графіт, світлий текст і золотий акцент",
    "Детали": "Деталі",
    "Детский": "Дитячий",
    "Детское": "Дитяче",
    "Диагонали, жирный курсив и контраст": "Діагоналі, жирний курсив і контраст",
    "До 40 часов без подзарядки": "До 40 годин без підзарядки",
    "До 5 ракурсов, главное пойдёт на обложку": "До 5 ракурсів, головний піде на обкладинку",
    "Добавить {0}": "Додати {0}",
    "Добавить строку": "Додати рядок",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "Додайте в текст властивості товару або рядки на кшталт «Вага: 250 г»",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "Додайте щонайменше {0} переваги, кожну з нового рядка",
    "Дом": "Дім",
    "доставку, возврат": "доставку, повернення",
    "другое": "інше",
    "Еда": "Їжа",
    "ещё {0}": "ще {0}",
    "Журнал": "Журнал",
    "за слайд": "за слайд",
    "Загружаем фото": "Завантажуємо фото",
    "Загрузите фото товара": "Завантажте фото товару",
    "Заполнить из описания": "Заповнити з опису",
    "Зарядка": "Зарядка",
    "заявления об оригинальности": "заяви про оригінальність",
    "Значение": "Значення",
    "Значение {0}": "Значення {0}",
    "Из фотосессии товара · главное фото на обложке": "Із фотосесії товару · головне фото на обкладинці",
    "Изменить текст": "Змінити текст",
    "Искать среди {0} оформлений": "Шукати серед {0} оформлень",
    "К описанию": "До опису",
    "карусель": "карусель",
    "Ко всем оформлениям": "До всіх оформлень",
    "Комплектация": "Комплектація",
    "Красота": "Краса",
    "Крафт, бежевый и приглушённый зелёный": "Крафт, бежевий і приглушений зелений",
    "Круглые формы, тёплый фон и крупные значки": "Круглі форми, теплий фон і великі значки",
    "Крупная антиква и свободная вёрстка": "Велика антиква і вільна верстка",
    "места нет": "місця немає",
    "Минимал": "Мінімал",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "Можна піти з екрана: бот напише, коли слайди будуть готові.",
    "Мягкие амбушюры": "М’які амбушури",
    "Мягкие амбушюры из эко-кожи": "М’які амбушури з екошкіри",
    "Мягкие градиенты и глянцевый подиум": "М’які градієнти і глянцевий подіум",
    "на слайдах": "на слайдах",
    "Набираем текст шаблоном": "Набираємо текст шаблоном",
    "Набираем шрифтом, без ошибок нейросети": "Набираємо шрифтом, без помилок нейромережі",
    "Нажмите, чтобы выбрать оформление": "Натисніть, щоб вибрати оформлення",
    "Название длиннее {0} знаков": "Назва довша за {0} знаків",
    "Название и от {0} преимуществ": "Назва і від {0} переваг",
    "Название и преимущества": "Назва і переваги",
    "Название и преимущество": "Назва і перевага",
    "Название товара": "Назва товару",
    "Найти преимущества": "Знайти переваги",
    "Напишите заголовок или текст": "Напишіть заголовок або текст",
    "Напишите название товара первой строкой": "Напишіть назву товару першим рядком",
    "Насыщенный фон и крупные плашки с цифрами": "Насичений фон і великі плашки з цифрами",
    "Не взяли {0}: на фото площадки так нельзя": "Не взяли {0}: на фото майданчика так не можна",
    "Не получилось собрать слайды": "Не вдалося зібрати слайди",
    "Не удалось перерисовать слайд. Текст остался прежним.": "Не вдалося перемалювати слайд. Текст лишився попереднім.",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "Не вдалося розібрати опис. Спробуйте ще раз.",
    "Нечего добавить, вернитесь к описанию": "Нічого додати, поверніться до опису",
    "Нужно от {0} знаков описания": "Потрібно від {0} знаків опису",
    "Об оформлении": "Про оформлення",
    "обещания": "обіцянки",
    "Обложка": "Обкладинка",
    "Одежда": "Одяг",
    "Описание длиннее {0} знаков": "Опис довший за {0} знаків",
    "Описание или характеристики": "Опис або характеристики",
    "Отметьте, что добавить": "Позначте, що додати",
    "Оформление «{0}»": "Оформлення «{0}»",
    "Оформления": "Оформлення",
    "Пастель": "Пастель",
    "Перед скачиванием уберите": "Перед завантаженням приберіть",
    "Перерисовываем слайд…": "Перемальовуємо слайд…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "Перемалюємо слайд тим самим шаблоном, без нової генерації.",
    "Подтвердите права на фото": "Підтвердьте права на фото",
    "Подтверждаю право использовать фото товара": "Підтверджую право використовувати фото товару",
    "Подходит для": "Підходить для",
    "Поиск оформлений": "Пошук оформлень",
    "поместится {0}": "поміститься {0}",
    "Поместится только {0}: снимите другую отметку": "Поміститься лише {0}: зніміть іншу позначку",
    "Попробуйте другое слово или сбросьте категорию": "Спробуйте інше слово або скиньте категорію",
    "Права на фото товара": "Права на фото товару",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Правку не підтверджено. Продовжте перевірку того самого запиту.",
    "превосходные степени": "найвищі ступені",
    "Предыдущий слайд": "Попередній слайд",
    "Преимуществ до {0}: уберите лишние строки": "Переваг до {0}: приберіть зайві рядки",
    "Преимуществ уже шесть: уберите лишнее в форме": "Переваг уже шість: приберіть зайве у формі",
    "Преимуществ: {0} из {1}": "Переваг: {0} з {1}",
    "Преимущество {0}": "Перевага {0}",
    "Преимущество длиннее {0} знаков: сократите строку": "Перевага довша за {0} знаків: скоротіть рядок",
    "Премиум": "Преміум",
    "призывы": "заклики",
    "Проверьте описание: сервер его не принял.": "Перевірте опис: сервер його не прийняв.",
    "Проверьте текст слайда: сервер его не принял.": "Перевірте текст слайда: сервер його не прийняв.",
    "Проверяем фото и текст": "Перевіряємо фото і текст",
    "Разбор описания пока недоступен. Заполните поле вручную.": "Розбір опису поки недоступний. Заповніть поле вручну.",
    "Размер": "Розмір",
    "Рисуем фон без текста": "Малюємо фон без тексту",
    "С надписями": "З написами",
    "Светлое дерево и мягкие тени": "Світле дерево і м’які тіні",
    "Светлый фон, тонкий шрифт и много воздуха": "Світлий фон, тонкий шрифт і багато повітря",
    "Свойство": "Властивість",
    "Свойство {0}": "Властивість {0}",
    "Сделайте снимок или закройте камеру": "Зробіть знімок або закрийте камеру",
    "Сетка, выноски и моноширинные цифры": "Сітка, виноски і моноширинні цифри",
    "Сканди": "Сканді",
    "Скачать всё": "Завантажити все",
    "Сколько слайдов": "Скільки слайдів",
    "слайд": "слайд",
    "Слайд {0}": "Слайд {0}",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Слайд уже змінено. Ми оновили результат — перевірте текст і збережіть знову.",
    "слайда": "слайди",
    "слайдов": "слайдів",
    "слайды": "слайди",
    "Слайды готовы": "Слайди готові",
    "Слайды ещё загружаются": "Слайди ще завантажуються",
    "Слайды набора": "Слайди набору",
    "слайды не созданы": "слайди не створено",
    "Слайды с преимуществами": "Слайди з перевагами",
    "Следующий слайд": "Наступний слайд",
    "Собираем слайды": "Збираємо слайди",
    "Создать {0}": "Створити {0}",
    "Создать {0} {1} · {2} C": "Створити {0} {1} · {2} C",
    "Спорт": "Спорт",
    "сравнения": "порівняння",
    "ссылки, контакты": "посилання, контакти",
    "Стекло": "Скло",
    "Страна": "Країна",
    "строк": "рядків",
    "строка": "рядок",
    "строки": "рядки",
    "Текст длиннее {0} знаков": "Текст довший за {0} знаків",
    "Текст на слайдах": "Текст на слайдах",
    "Текст набран": "Текст набрано",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Текст не вміщується на слайд. Скоротіть заголовок або текст.",
    "Технический": "Технічний",
    "Товар в сцене": "Товар у сцені",
    "Товар вырезан": "Товар вирізано",
    "Тут откроется тема чата, куда бот прислал слайды": "Тут відкриється тема чату, куди бот надіслав слайди",
    "Уберите": "Приберіть",
    "Убрать строку {0}": "Прибрати рядок {0}",
    "Удерживайте, чтобы посмотреть все слайды": "Утримуйте, щоб переглянути всі слайди",
    "Фон готов": "Фон готовий",
    "Фото и текст проверены": "Фото і текст перевірено",
    "Фото или текст не прошли проверку": "Фото або текст не пройшли перевірку",
    "Характеристик уже восемь": "Характеристик уже вісім",
    "Характеристики": "Характеристики",
    "Цветная сцена и прозрачные плашки": "Кольорова сцена і прозорі плашки",
    "Цена": "Ціна",
    "Цены, призывы и превосходные степени не возьмём": "Ціни, заклики і найвищі ступені не візьмемо",
    "цены, скидки": "ціни, знижки",
    "Что нашли": "Що знайшли",
    "шаблон": "шаблон",
    "шаблона": "шаблони",
    "шаблонов": "шаблонів",
    "Эко": "Еко",
    "Электроника": "Електроніка",
    "Этот вариант пока недоступен": "Цей варіант поки недоступний",
    "Этот слайд больше нельзя изменить.": "Цей слайд більше не можна змінити.",
    "Этот слайд нельзя изменить": "Цей слайд не можна змінити",
    "Я.Маркет": "Я.Маркет",
    "Яркий": "Яскравий",
    "C за слайд": "C за слайд",
    "Ozon Fresh принимает обложку только без текста": "Ozon Fresh приймає лише обкладинку без тексту"
  },
  "zh": {
    "· обложка без надписей": "· 封面不带文字",
    "{0} {1}: {2} не принимает на фото {3}": "{0} {1}：{2} 不允许照片中出现{3}",
    "{0}, слайд {1}": "{0}，幻灯片 {1}",
    "{0}, слайд {1} из {2}": "{0}，幻灯片 {1} / {2}",
    "18 × 16 × 8 см": "18 × 16 × 8 厘米",
    "250 г": "250 克",
    "40 ч": "40 小时",
    "Активное шумоподавление": "主动降噪",
    "Без надписей": "不带文字",
    "Беспроводные наушники": "无线耳机",
    "Бот уже прислал их в чат, в отдельную тему. Текст набран шаблоном, без ошибок нейросети: нажмите на него на слайде, чтобы исправить.": "机器人已把它们发到聊天的单独话题中。文字由模板排版，没有 AI 错字：在幻灯片上点击文字即可修改。",
    "Быстрая зарядка за 10 минут": "10 分钟快速充电",
    "В описании не нашлось фактов о товаре. Добавьте подробности.": "描述中没有找到商品信息。请补充细节。",
    "Вес": "重量",
    "Видео товара, 5 сек": "商品视频，5 秒",
    "Возьмём только факты из вашего текста": "我们只采用你文字中的事实",
    "Время работы": "续航时间",
    "Все оформления": "全部设计",
    "Вставьте описание с карточки или от поставщика. Строки вида «Вес: 250 г» станут характеристиками": "粘贴商品卡片或供应商提供的描述。「重量：250 克」这样的行会变成规格参数",
    "Вырезаем товар": "正在抠出商品",
    "Главное фото как есть": "主照片保持原样",
    "Главное фото на обложку, остальные в слайды": "主照片用作封面，其余放入幻灯片",
    "Главное фото пойдёт на обложку": "主照片将用作封面",
    "Глубина": "深度",
    "Графит, светлый текст и золотой акцент": "石墨色、浅色文字和金色点缀",
    "Детали": "细节",
    "Детский": "儿童",
    "Детское": "儿童",
    "Диагонали, жирный курсив и контраст": "斜线、粗斜体和强对比",
    "До 40 часов без подзарядки": "不充电可用 40 小时",
    "До 5 ракурсов, главное пойдёт на обложку": "最多 5 个角度，主照片用作封面",
    "Добавить {0}": "添加{0}",
    "Добавить строку": "添加一行",
    "Добавьте в текст свойства товара или строки вида «Вес: 250 г»": "在文字中添加商品特性，或「重量：250 克」这样的行",
    "Добавьте хотя бы {0} преимущества, каждое с новой строки": "至少添加 {0} 个卖点，每行一个",
    "Дом": "家居",
    "доставку, возврат": "配送、退货",
    "другое": "其他",
    "Еда": "食品",
    "ещё {0}": "还有 {0}",
    "Журнал": "杂志",
    "за слайд": "每张幻灯片",
    "Загружаем фото": "正在上传照片",
    "Загрузите фото товара": "上传商品照片",
    "Заполнить из описания": "从描述中填写",
    "Зарядка": "充电",
    "заявления об оригинальности": "原创声明",
    "Значение": "数值",
    "Значение {0}": "数值 {0}",
    "Из фотосессии товара · главное фото на обложке": "来自商品写真 · 主照片在封面上",
    "Изменить текст": "修改文字",
    "Искать среди {0} оформлений": "在 {0} 种设计中搜索",
    "К описанию": "返回描述",
    "карусель": "轮播",
    "Ко всем оформлениям": "返回全部设计",
    "Комплектация": "包装清单",
    "Красота": "美妆",
    "Крафт, бежевый и приглушённый зелёный": "牛皮纸、米色和柔和的绿色",
    "Круглые формы, тёплый фон и крупные значки": "圆润造型、暖色背景和大图标",
    "Крупная антиква и свободная вёрстка": "大号衬线字体和舒展排版",
    "места нет": "没有空间",
    "Минимал": "极简",
    "Можно уйти с экрана: бот напишет, когда слайды будут готовы.": "可以离开此页面：幻灯片完成后机器人会通知你。",
    "Мягкие амбушюры": "柔软耳垫",
    "Мягкие амбушюры из эко-кожи": "柔软的环保皮革耳垫",
    "Мягкие градиенты и глянцевый подиум": "柔和渐变和光面展台",
    "на слайдах": "在幻灯片上",
    "Набираем текст шаблоном": "正在用模板排版文字",
    "Набираем шрифтом, без ошибок нейросети": "用字体排版，没有 AI 错字",
    "Нажмите, чтобы выбрать оформление": "点击选择设计",
    "Название длиннее {0} знаков": "名称超过 {0} 个字符",
    "Название и от {0} преимуществ": "名称和至少 {0} 个卖点",
    "Название и преимущества": "名称和卖点",
    "Название и преимущество": "名称和一个卖点",
    "Название товара": "商品名称",
    "Найти преимущества": "提取卖点",
    "Напишите заголовок или текст": "输入标题或文字",
    "Напишите название товара первой строкой": "第一行写商品名称",
    "Насыщенный фон и крупные плашки с цифрами": "饱和背景和大号数字标签",
    "Не взяли {0}: на фото площадки так нельзя": "已跳过{0}：平台不允许照片中出现",
    "Не получилось собрать слайды": "幻灯片生成失败",
    "Не удалось перерисовать слайд. Текст остался прежним.": "幻灯片重绘失败。文字保持不变。",
    "Не удалось разобрать описание. Попробуйте ещё раз.": "无法解析描述。请重试。",
    "Нечего добавить, вернитесь к описанию": "没有可添加的内容，请返回描述",
    "Нужно от {0} знаков описания": "描述至少需要 {0} 个字符",
    "Об оформлении": "关于设计",
    "обещания": "承诺",
    "Обложка": "封面",
    "Одежда": "服装",
    "Описание длиннее {0} знаков": "描述超过 {0} 个字符",
    "Описание или характеристики": "描述或规格参数",
    "Отметьте, что добавить": "勾选要添加的内容",
    "Оформление «{0}»": "设计「{0}」",
    "Оформления": "设计",
    "Пастель": "粉彩",
    "Перед скачиванием уберите": "下载前请删除",
    "Перерисовываем слайд…": "正在重绘幻灯片…",
    "Перерисуем слайд тем же шаблоном, без новой генерации.": "我们会用同一模板重绘幻灯片，不重新生成。",
    "Подтвердите права на фото": "请确认照片使用权",
    "Подтверждаю право использовать фото товара": "我确认有权使用商品照片",
    "Подходит для": "适用于",
    "Поиск оформлений": "搜索设计",
    "поместится {0}": "可容纳 {0}",
    "Поместится только {0}: снимите другую отметку": "只能容纳 {0}：请取消其他勾选",
    "Попробуйте другое слово или сбросьте категорию": "试试其他关键词或重置类别",
    "Права на фото товара": "商品照片使用权",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "修改尚未确认。请继续检查同一请求。",
    "превосходные степени": "最高级用语",
    "Предыдущий слайд": "上一张幻灯片",
    "Преимуществ до {0}: уберите лишние строки": "最多 {0} 个卖点：请删除多余的行",
    "Преимуществ уже шесть: уберите лишнее в форме": "已有六个卖点：请在表单中删掉一些",
    "Преимуществ: {0} из {1}": "卖点：{0} / {1}",
    "Преимущество {0}": "卖点 {0}",
    "Преимущество длиннее {0} знаков: сократите строку": "卖点超过 {0} 个字符：请缩短",
    "Премиум": "高级",
    "призывы": "号召语",
    "Проверьте описание: сервер его не принял.": "请检查描述：服务器未接受。",
    "Проверьте текст слайда: сервер его не принял.": "请检查幻灯片文字：服务器未接受。",
    "Проверяем фото и текст": "正在检查照片和文字",
    "Разбор описания пока недоступен. Заполните поле вручную.": "描述解析暂不可用。请手动填写。",
    "Размер": "尺寸",
    "Рисуем фон без текста": "正在绘制无文字背景",
    "С надписями": "带文字",
    "Светлое дерево и мягкие тени": "浅色木纹和柔和阴影",
    "Светлый фон, тонкий шрифт и много воздуха": "浅色背景、细字体和大量留白",
    "Свойство": "特性",
    "Свойство {0}": "特性 {0}",
    "Сделайте снимок или закройте камеру": "拍一张或关闭相机",
    "Сетка, выноски и моноширинные цифры": "网格、标注和等宽数字",
    "Сканди": "北欧",
    "Скачать всё": "全部下载",
    "Сколько слайдов": "幻灯片数量",
    "слайд": "张幻灯片",
    "Слайд {0}": "幻灯片 {0}",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "幻灯片已被修改。我们刷新了结果，请检查文字后再次保存。",
    "слайда": "张幻灯片",
    "слайдов": "张幻灯片",
    "слайды": "幻灯片",
    "Слайды готовы": "幻灯片已完成",
    "Слайды ещё загружаются": "幻灯片仍在加载",
    "Слайды набора": "套组中的幻灯片",
    "слайды не созданы": "幻灯片未创建",
    "Слайды с преимуществами": "卖点幻灯片",
    "Следующий слайд": "下一张幻灯片",
    "Собираем слайды": "正在生成幻灯片",
    "Создать {0}": "创建{0}",
    "Создать {0} {1} · {2} C": "创建 {0} {1} · {2} C",
    "Спорт": "运动",
    "сравнения": "比较",
    "ссылки, контакты": "链接、联系方式",
    "Стекло": "玻璃",
    "Страна": "国家",
    "строк": "行",
    "строка": "行",
    "строки": "行",
    "Текст длиннее {0} знаков": "文字超过 {0} 个字符",
    "Текст на слайдах": "幻灯片上的文字",
    "Текст набран": "文字已排版",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "文字放不下这张幻灯片。请缩短标题或正文。",
    "Технический": "科技",
    "Товар в сцене": "场景中的商品",
    "Товар вырезан": "商品已抠出",
    "Тут откроется тема чата, куда бот прислал слайды": "这里会打开机器人发送幻灯片的聊天话题",
    "Уберите": "请删除",
    "Убрать строку {0}": "删除第 {0} 行",
    "Удерживайте, чтобы посмотреть все слайды": "长按查看全部幻灯片",
    "Фон готов": "背景已就绪",
    "Фото и текст проверены": "照片和文字已检查",
    "Фото или текст не прошли проверку": "照片或文字未通过审核",
    "Характеристик уже восемь": "已有八项规格参数",
    "Характеристики": "规格参数",
    "Цветная сцена и прозрачные плашки": "多彩场景和透明标签",
    "Цена": "价格",
    "Цены, призывы и превосходные степени не возьмём": "不采用价格、号召语和最高级用语",
    "цены, скидки": "价格、折扣",
    "Что нашли": "找到的内容",
    "шаблон": "个模板",
    "шаблона": "个模板",
    "шаблонов": "个模板",
    "Эко": "环保",
    "Электроника": "电子产品",
    "Этот вариант пока недоступен": "此选项暂不可用",
    "Этот слайд больше нельзя изменить.": "此幻灯片已无法修改。",
    "Этот слайд нельзя изменить": "此幻灯片无法修改",
    "Я.Маркет": "Yandex Market",
    "Яркий": "鲜艳",
    "C за слайд": "C / 张幻灯片",
    "Ozon Fresh принимает обложку только без текста": "Ozon Fresh 只接受不带文字的封面"
  }
}
